//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class ReportingBaseClient {
    constructor() {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected getBaseUrl(_: string, baseUrl?: string): string {
        return environment.reportingApiUrl;
    }
}

export interface IAccountClient {
    /**
     * @return OK
     */
    accountGetAccountValues(body: GetAccountValuesParameters): Observable<GetAccountValuesResultType[]>;
    /**
     * @return OK
     */
    accountGetAccountBoxesValues(body: GetAccountValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    accountGetAccountColumnChartValues(body: GetAccountValuesParameters): Observable<GetAccountColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    accountGetAccountMetricsValues(body: GetAccountValuesParameters): Observable<GetAccountMetricsValuesResultType>;
    /**
     * @return OK
     */
    accountGetAccountLineChartValues(body: GetAccountValuesParameters): Observable<GetAccountLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    accountSearchBasicData(body: SearchAccountsBasicDataParameters): Observable<SearchAccountsBasicDataResultDto[]>;
    /**
     * @return OK
     */
    accountGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]>;
    /**
     * @return OK
     */
    accountSaveCustomReport(body: CustomReportAccountView): Observable<CustomReportAccountView>;
    /**
     * @return OK
     */
    accountSaveCatalogReport(body: CustomReportAccountView): Observable<CustomReportAccountView>;
    /**
     * @return OK
     */
    accountGetCustomReport(id: number): Observable<CustomReportAccountView>;
    /**
     * @return OK
     */
    accountCreateSharedReport(body: CustomReportAccountView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    accountGetSharedReport(id: string): Observable<CustomReportAccountView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    accountResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class AccountClient extends ReportingBaseClient implements IAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    accountGetAccountValues(body: GetAccountValuesParameters): Observable<GetAccountValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Account/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetAccountValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetAccountValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccountValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccountValuesResultType[]>;
        }));
    }

    protected processAccountGetAccountValues(response: HttpResponseBase): Observable<GetAccountValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAccountValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountGetAccountBoxesValues(body: GetAccountValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/Account/account-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetAccountBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetAccountBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processAccountGetAccountBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountGetAccountColumnChartValues(body: GetAccountValuesParameters): Observable<GetAccountColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Account/account-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetAccountColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetAccountColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccountColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccountColumnChartValuesResultType[]>;
        }));
    }

    protected processAccountGetAccountColumnChartValues(response: HttpResponseBase): Observable<GetAccountColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAccountColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountGetAccountMetricsValues(body: GetAccountValuesParameters): Observable<GetAccountMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/Account/account-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetAccountMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetAccountMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccountMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccountMetricsValuesResultType>;
        }));
    }

    protected processAccountGetAccountMetricsValues(response: HttpResponseBase): Observable<GetAccountMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAccountMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountGetAccountLineChartValues(body: GetAccountValuesParameters): Observable<GetAccountLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Account/account-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetAccountLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetAccountLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccountLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccountLineChartValuesResultType[]>;
        }));
    }

    protected processAccountGetAccountLineChartValues(response: HttpResponseBase): Observable<GetAccountLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAccountLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountSearchBasicData(body: SearchAccountsBasicDataParameters): Observable<SearchAccountsBasicDataResultDto[]> {
        let url_ = this.baseUrl + "/api/Account/basic-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountSearchBasicData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountSearchBasicData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchAccountsBasicDataResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchAccountsBasicDataResultDto[]>;
        }));
    }

    protected processAccountSearchBasicData(response: HttpResponseBase): Observable<SearchAccountsBasicDataResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchAccountsBasicDataResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]> {
        let url_ = this.baseUrl + "/api/Account/custom-field-columns?";
        if (organizationIds === undefined || organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' must be defined and cannot be null.");
        else
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetCustomFieldColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetCustomFieldColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCustomFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCustomFieldDto[]>;
        }));
    }

    protected processAccountGetCustomFieldColumns(response: HttpResponseBase): Observable<EntityTypeCustomFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCustomFieldDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountSaveCustomReport(body: CustomReportAccountView): Observable<CustomReportAccountView> {
        let url_ = this.baseUrl + "/api/Account/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAccountView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAccountView>;
        }));
    }

    protected processAccountSaveCustomReport(response: HttpResponseBase): Observable<CustomReportAccountView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAccountView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountSaveCatalogReport(body: CustomReportAccountView): Observable<CustomReportAccountView> {
        let url_ = this.baseUrl + "/api/Account/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAccountView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAccountView>;
        }));
    }

    protected processAccountSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportAccountView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAccountView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountGetCustomReport(id: number): Observable<CustomReportAccountView> {
        let url_ = this.baseUrl + "/api/Account/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAccountView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAccountView>;
        }));
    }

    protected processAccountGetCustomReport(response: HttpResponseBase): Observable<CustomReportAccountView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAccountView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountCreateSharedReport(body: CustomReportAccountView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/Account/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processAccountCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountGetSharedReport(id: string): Observable<CustomReportAccountView> {
        let url_ = this.baseUrl + "/api/Account/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAccountView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAccountView>;
        }));
    }

    protected processAccountGetSharedReport(response: HttpResponseBase): Observable<CustomReportAccountView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAccountView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    accountResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/Account/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processAccountResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAwardedEstimateClient {
    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedValues(body: GetEstimateAwardedValuesParameters): Observable<GetEstimateAwardedValuesResultType[]>;
    /**
     * @return OK
     */
    awardedEstimateGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]>;
    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedBoxesValues(body: GetEstimateAwardedValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedColumnChartValues(body: GetEstimateAwardedValuesParameters): Observable<GetEstimateAwardedColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedMetricsValues(body: GetEstimateAwardedValuesParameters): Observable<GetEstimateAwardedMetricsValuesResultType>;
    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedLineChartValues(body: GetEstimateAwardedValuesParameters): Observable<GetEstimateAwardedLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    awardedEstimateSaveCustomReport(body: CustomReportAwardedEstimateView): Observable<CustomReportAwardedEstimateView>;
    /**
     * @return OK
     */
    awardedEstimateSaveCatalogReport(body: CustomReportAwardedEstimateView): Observable<CustomReportAwardedEstimateView>;
    /**
     * @return OK
     */
    awardedEstimateGetCustomReport(id: number): Observable<CustomReportAwardedEstimateView>;
    /**
     * @return OK
     */
    awardedEstimateCreateSharedReport(body: CustomReportAwardedEstimateView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    awardedEstimateGetSharedReport(id: string): Observable<CustomReportAwardedEstimateView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    awardedEstimateResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class AwardedEstimateClient extends ReportingBaseClient implements IAwardedEstimateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedValues(body: GetEstimateAwardedValuesParameters): Observable<GetEstimateAwardedValuesResultType[]> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/estimate-awarded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateGetEstimateAwardedValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateGetEstimateAwardedValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEstimateAwardedValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEstimateAwardedValuesResultType[]>;
        }));
    }

    protected processAwardedEstimateGetEstimateAwardedValues(response: HttpResponseBase): Observable<GetEstimateAwardedValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEstimateAwardedValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/custom-field-columns?";
        if (organizationIds === undefined || organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' must be defined and cannot be null.");
        else
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateGetCustomFieldColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateGetCustomFieldColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCustomFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCustomFieldDto[]>;
        }));
    }

    protected processAwardedEstimateGetCustomFieldColumns(response: HttpResponseBase): Observable<EntityTypeCustomFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCustomFieldDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedBoxesValues(body: GetEstimateAwardedValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/estimate-awarded-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateGetEstimateAwardedBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateGetEstimateAwardedBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processAwardedEstimateGetEstimateAwardedBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedColumnChartValues(body: GetEstimateAwardedValuesParameters): Observable<GetEstimateAwardedColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/estimate-awarded-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateGetEstimateAwardedColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateGetEstimateAwardedColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEstimateAwardedColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEstimateAwardedColumnChartValuesResultType[]>;
        }));
    }

    protected processAwardedEstimateGetEstimateAwardedColumnChartValues(response: HttpResponseBase): Observable<GetEstimateAwardedColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEstimateAwardedColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedMetricsValues(body: GetEstimateAwardedValuesParameters): Observable<GetEstimateAwardedMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/estimate-awarded-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateGetEstimateAwardedMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateGetEstimateAwardedMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEstimateAwardedMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEstimateAwardedMetricsValuesResultType>;
        }));
    }

    protected processAwardedEstimateGetEstimateAwardedMetricsValues(response: HttpResponseBase): Observable<GetEstimateAwardedMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEstimateAwardedMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateGetEstimateAwardedLineChartValues(body: GetEstimateAwardedValuesParameters): Observable<GetEstimateAwardedLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/estimate-awarded-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateGetEstimateAwardedLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateGetEstimateAwardedLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEstimateAwardedLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEstimateAwardedLineChartValuesResultType[]>;
        }));
    }

    protected processAwardedEstimateGetEstimateAwardedLineChartValues(response: HttpResponseBase): Observable<GetEstimateAwardedLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEstimateAwardedLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateSaveCustomReport(body: CustomReportAwardedEstimateView): Observable<CustomReportAwardedEstimateView> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAwardedEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAwardedEstimateView>;
        }));
    }

    protected processAwardedEstimateSaveCustomReport(response: HttpResponseBase): Observable<CustomReportAwardedEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAwardedEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateSaveCatalogReport(body: CustomReportAwardedEstimateView): Observable<CustomReportAwardedEstimateView> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAwardedEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAwardedEstimateView>;
        }));
    }

    protected processAwardedEstimateSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportAwardedEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAwardedEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateGetCustomReport(id: number): Observable<CustomReportAwardedEstimateView> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAwardedEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAwardedEstimateView>;
        }));
    }

    protected processAwardedEstimateGetCustomReport(response: HttpResponseBase): Observable<CustomReportAwardedEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAwardedEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateCreateSharedReport(body: CustomReportAwardedEstimateView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processAwardedEstimateCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    awardedEstimateGetSharedReport(id: string): Observable<CustomReportAwardedEstimateView> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAwardedEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAwardedEstimateView>;
        }));
    }

    protected processAwardedEstimateGetSharedReport(response: HttpResponseBase): Observable<CustomReportAwardedEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAwardedEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    awardedEstimateResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/AwardedEstimate/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAwardedEstimateResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAwardedEstimateResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processAwardedEstimateResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBaseEstimateClient {
    /**
     * @return OK
     */
    baseEstimateQuickSearch(body: QuickSearchEstimatesParameters): Observable<QuickSearchEstimatesResultDto[]>;
    /**
     * @return OK
     */
    baseEstimateGetByIds(ids: number[]): Observable<QuickSearchEstimatesResultDto[]>;
}

@Injectable({ providedIn: 'root' })
export class BaseEstimateClient extends ReportingBaseClient implements IBaseEstimateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    baseEstimateQuickSearch(body: QuickSearchEstimatesParameters): Observable<QuickSearchEstimatesResultDto[]> {
        let url_ = this.baseUrl + "/api/BaseEstimate/quick-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBaseEstimateQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBaseEstimateQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuickSearchEstimatesResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuickSearchEstimatesResultDto[]>;
        }));
    }

    protected processBaseEstimateQuickSearch(response: HttpResponseBase): Observable<QuickSearchEstimatesResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuickSearchEstimatesResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    baseEstimateGetByIds(ids: number[]): Observable<QuickSearchEstimatesResultDto[]> {
        let url_ = this.baseUrl + "/api/BaseEstimate/get-by-ids?";
        if (ids === undefined || ids === null)
            throw new globalThis.Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBaseEstimateGetByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBaseEstimateGetByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuickSearchEstimatesResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuickSearchEstimatesResultDto[]>;
        }));
    }

    protected processBaseEstimateGetByIds(response: HttpResponseBase): Observable<QuickSearchEstimatesResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuickSearchEstimatesResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBaseEstimateStatusClient {
    /**
     * @return OK
     */
    baseEstimateStatusGetById(id: number): Observable<BaseEstimateStatusDto>;
    /**
     * @return OK
     */
    baseEstimateStatusGetAll(): Observable<BaseEstimateStatusDto[]>;
    /**
     * @return OK
     */
    baseEstimateStatusGetByIds(ids: number[]): Observable<BaseEstimateStatusDto[]>;
}

@Injectable({ providedIn: 'root' })
export class BaseEstimateStatusClient extends ReportingBaseClient implements IBaseEstimateStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    baseEstimateStatusGetById(id: number): Observable<BaseEstimateStatusDto> {
        let url_ = this.baseUrl + "/api/BaseEstimateStatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBaseEstimateStatusGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBaseEstimateStatusGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseEstimateStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseEstimateStatusDto>;
        }));
    }

    protected processBaseEstimateStatusGetById(response: HttpResponseBase): Observable<BaseEstimateStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseEstimateStatusDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    baseEstimateStatusGetAll(): Observable<BaseEstimateStatusDto[]> {
        let url_ = this.baseUrl + "/api/BaseEstimateStatus/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBaseEstimateStatusGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBaseEstimateStatusGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseEstimateStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseEstimateStatusDto[]>;
        }));
    }

    protected processBaseEstimateStatusGetAll(response: HttpResponseBase): Observable<BaseEstimateStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseEstimateStatusDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    baseEstimateStatusGetByIds(ids: number[]): Observable<BaseEstimateStatusDto[]> {
        let url_ = this.baseUrl + "/api/BaseEstimateStatus/search?";
        if (ids === undefined || ids === null)
            throw new globalThis.Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBaseEstimateStatusGetByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBaseEstimateStatusGetByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseEstimateStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseEstimateStatusDto[]>;
        }));
    }

    protected processBaseEstimateStatusGetByIds(response: HttpResponseBase): Observable<BaseEstimateStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseEstimateStatusDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBuildingClient {
    /**
     * @return OK
     */
    buildingGetBuildingValues(body: GetBuildingValuesParameters): Observable<GetBuildingValuesResultType[]>;
    /**
     * @return OK
     */
    buildingGetBuildingBoxesValues(body: GetBuildingValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    buildingGetBuildingColumnChartValues(body: GetBuildingValuesParameters): Observable<GetBuildingColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    buildingGetBuildingMetricsValues(body: GetBuildingValuesParameters): Observable<GetBuildingMetricsValuesResultType>;
    /**
     * @return OK
     */
    buildingGetBuildingLineChartValues(body: GetBuildingValuesParameters): Observable<GetBuildingLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    buildingGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]>;
    /**
     * @return OK
     */
    buildingSaveCustomReport(body: CustomReportBuildingView): Observable<CustomReportBuildingView>;
    /**
     * @return OK
     */
    buildingSaveCatalogReport(body: CustomReportBuildingView): Observable<CustomReportBuildingView>;
    /**
     * @return OK
     */
    buildingGetCustomReport(id: number): Observable<CustomReportBuildingView>;
    /**
     * @return OK
     */
    buildingCreateSharedReport(body: CustomReportBuildingView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    buildingGetSharedReport(id: string): Observable<CustomReportBuildingView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    buildingResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class BuildingClient extends ReportingBaseClient implements IBuildingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    buildingGetBuildingValues(body: GetBuildingValuesParameters): Observable<GetBuildingValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Building/building";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingGetBuildingValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingGetBuildingValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingValuesResultType[]>;
        }));
    }

    protected processBuildingGetBuildingValues(response: HttpResponseBase): Observable<GetBuildingValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBuildingValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingGetBuildingBoxesValues(body: GetBuildingValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/Building/building-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingGetBuildingBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingGetBuildingBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processBuildingGetBuildingBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingGetBuildingColumnChartValues(body: GetBuildingValuesParameters): Observable<GetBuildingColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Building/building-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingGetBuildingColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingGetBuildingColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingColumnChartValuesResultType[]>;
        }));
    }

    protected processBuildingGetBuildingColumnChartValues(response: HttpResponseBase): Observable<GetBuildingColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBuildingColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingGetBuildingMetricsValues(body: GetBuildingValuesParameters): Observable<GetBuildingMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/Building/building-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingGetBuildingMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingGetBuildingMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingMetricsValuesResultType>;
        }));
    }

    protected processBuildingGetBuildingMetricsValues(response: HttpResponseBase): Observable<GetBuildingMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBuildingMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingGetBuildingLineChartValues(body: GetBuildingValuesParameters): Observable<GetBuildingLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Building/building-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingGetBuildingLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingGetBuildingLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingLineChartValuesResultType[]>;
        }));
    }

    protected processBuildingGetBuildingLineChartValues(response: HttpResponseBase): Observable<GetBuildingLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBuildingLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]> {
        let url_ = this.baseUrl + "/api/Building/custom-field-columns?";
        if (organizationIds === undefined || organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' must be defined and cannot be null.");
        else
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingGetCustomFieldColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingGetCustomFieldColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCustomFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCustomFieldDto[]>;
        }));
    }

    protected processBuildingGetCustomFieldColumns(response: HttpResponseBase): Observable<EntityTypeCustomFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCustomFieldDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingSaveCustomReport(body: CustomReportBuildingView): Observable<CustomReportBuildingView> {
        let url_ = this.baseUrl + "/api/Building/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportBuildingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportBuildingView>;
        }));
    }

    protected processBuildingSaveCustomReport(response: HttpResponseBase): Observable<CustomReportBuildingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportBuildingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingSaveCatalogReport(body: CustomReportBuildingView): Observable<CustomReportBuildingView> {
        let url_ = this.baseUrl + "/api/Building/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportBuildingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportBuildingView>;
        }));
    }

    protected processBuildingSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportBuildingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportBuildingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingGetCustomReport(id: number): Observable<CustomReportBuildingView> {
        let url_ = this.baseUrl + "/api/Building/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportBuildingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportBuildingView>;
        }));
    }

    protected processBuildingGetCustomReport(response: HttpResponseBase): Observable<CustomReportBuildingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportBuildingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingCreateSharedReport(body: CustomReportBuildingView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/Building/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processBuildingCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingGetSharedReport(id: string): Observable<CustomReportBuildingView> {
        let url_ = this.baseUrl + "/api/Building/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportBuildingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportBuildingView>;
        }));
    }

    protected processBuildingGetSharedReport(response: HttpResponseBase): Observable<CustomReportBuildingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportBuildingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    buildingResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/Building/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processBuildingResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IChangeOrdersClient {
    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersValues(body: GetChangeOrdersValuesParameters): Observable<GetExternalChangeOrderValuesResultType[]>;
    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersMetricsValues(body: GetChangeOrdersValuesParameters): Observable<GetChangeOrdersMetricsFormattedValuesResultType>;
    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersBoxesValues(body: GetChangeOrdersValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersLineChartValues(body: GetChangeOrdersValuesParameters): Observable<GetChangeOrdersLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersColumnChartValues(body: GetChangeOrdersValuesParameters): Observable<GetChangeOrdersColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    changeOrdersSaveCustomReport(body: CustomReportChangeOrderView): Observable<CustomReportChangeOrderView>;
    /**
     * @return OK
     */
    changeOrdersSaveCatalogReport(body: CustomReportChangeOrderView): Observable<CustomReportChangeOrderView>;
    /**
     * @return OK
     */
    changeOrdersGetCustomReport(id: number): Observable<CustomReportChangeOrderView>;
    /**
     * @return OK
     */
    changeOrdersCreateSharedReport(body: CustomReportChangeOrderView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    changeOrdersGetSharedReport(id: string): Observable<CustomReportChangeOrderView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    changeOrdersResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ChangeOrdersClient extends ReportingBaseClient implements IChangeOrdersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersValues(body: GetChangeOrdersValuesParameters): Observable<GetExternalChangeOrderValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ChangeOrders/change-orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersGetChangeOrdersValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersGetChangeOrdersValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExternalChangeOrderValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExternalChangeOrderValuesResultType[]>;
        }));
    }

    protected processChangeOrdersGetChangeOrdersValues(response: HttpResponseBase): Observable<GetExternalChangeOrderValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetExternalChangeOrderValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersMetricsValues(body: GetChangeOrdersValuesParameters): Observable<GetChangeOrdersMetricsFormattedValuesResultType> {
        let url_ = this.baseUrl + "/api/ChangeOrders/change-orders-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersGetChangeOrdersMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersGetChangeOrdersMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetChangeOrdersMetricsFormattedValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetChangeOrdersMetricsFormattedValuesResultType>;
        }));
    }

    protected processChangeOrdersGetChangeOrdersMetricsValues(response: HttpResponseBase): Observable<GetChangeOrdersMetricsFormattedValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetChangeOrdersMetricsFormattedValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersBoxesValues(body: GetChangeOrdersValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ChangeOrders/change-orders-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersGetChangeOrdersBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersGetChangeOrdersBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processChangeOrdersGetChangeOrdersBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersLineChartValues(body: GetChangeOrdersValuesParameters): Observable<GetChangeOrdersLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ChangeOrders/change-orders-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersGetChangeOrdersLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersGetChangeOrdersLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetChangeOrdersLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetChangeOrdersLineChartValuesResultType[]>;
        }));
    }

    protected processChangeOrdersGetChangeOrdersLineChartValues(response: HttpResponseBase): Observable<GetChangeOrdersLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetChangeOrdersLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrdersGetChangeOrdersColumnChartValues(body: GetChangeOrdersValuesParameters): Observable<GetChangeOrdersColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ChangeOrders/change-orders-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersGetChangeOrdersColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersGetChangeOrdersColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetChangeOrdersColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetChangeOrdersColumnChartValuesResultType[]>;
        }));
    }

    protected processChangeOrdersGetChangeOrdersColumnChartValues(response: HttpResponseBase): Observable<GetChangeOrdersColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetChangeOrdersColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrdersSaveCustomReport(body: CustomReportChangeOrderView): Observable<CustomReportChangeOrderView> {
        let url_ = this.baseUrl + "/api/ChangeOrders/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportChangeOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportChangeOrderView>;
        }));
    }

    protected processChangeOrdersSaveCustomReport(response: HttpResponseBase): Observable<CustomReportChangeOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportChangeOrderView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrdersSaveCatalogReport(body: CustomReportChangeOrderView): Observable<CustomReportChangeOrderView> {
        let url_ = this.baseUrl + "/api/ChangeOrders/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportChangeOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportChangeOrderView>;
        }));
    }

    protected processChangeOrdersSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportChangeOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportChangeOrderView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrdersGetCustomReport(id: number): Observable<CustomReportChangeOrderView> {
        let url_ = this.baseUrl + "/api/ChangeOrders/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportChangeOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportChangeOrderView>;
        }));
    }

    protected processChangeOrdersGetCustomReport(response: HttpResponseBase): Observable<CustomReportChangeOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportChangeOrderView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrdersCreateSharedReport(body: CustomReportChangeOrderView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ChangeOrders/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processChangeOrdersCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrdersGetSharedReport(id: string): Observable<CustomReportChangeOrderView> {
        let url_ = this.baseUrl + "/api/ChangeOrders/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportChangeOrderView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportChangeOrderView>;
        }));
    }

    protected processChangeOrdersGetSharedReport(response: HttpResponseBase): Observable<CustomReportChangeOrderView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportChangeOrderView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    changeOrdersResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ChangeOrders/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrdersResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrdersResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processChangeOrdersResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IChangeOrderStatusClient {
    /**
     * @return OK
     */
    changeOrderStatusGetById(id: number): Observable<ChangeOrderStatusDto>;
    /**
     * @return OK
     */
    changeOrderStatusGetAll(): Observable<ChangeOrderStatusDto[]>;
    /**
     * @return OK
     */
    changeOrderStatusGetByIds(ids: number[]): Observable<ChangeOrderStatusDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ChangeOrderStatusClient extends ReportingBaseClient implements IChangeOrderStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    changeOrderStatusGetById(id: number): Observable<ChangeOrderStatusDto> {
        let url_ = this.baseUrl + "/api/ChangeOrderStatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrderStatusGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrderStatusGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeOrderStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeOrderStatusDto>;
        }));
    }

    protected processChangeOrderStatusGetById(response: HttpResponseBase): Observable<ChangeOrderStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeOrderStatusDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrderStatusGetAll(): Observable<ChangeOrderStatusDto[]> {
        let url_ = this.baseUrl + "/api/ChangeOrderStatus/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrderStatusGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrderStatusGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeOrderStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeOrderStatusDto[]>;
        }));
    }

    protected processChangeOrderStatusGetAll(response: HttpResponseBase): Observable<ChangeOrderStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeOrderStatusDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeOrderStatusGetByIds(ids: number[]): Observable<ChangeOrderStatusDto[]> {
        let url_ = this.baseUrl + "/api/ChangeOrderStatus/search?";
        if (ids === undefined || ids === null)
            throw new globalThis.Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrderStatusGetByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrderStatusGetByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeOrderStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeOrderStatusDto[]>;
        }));
    }

    protected processChangeOrderStatusGetByIds(response: HttpResponseBase): Observable<ChangeOrderStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeOrderStatusDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyClient {
    /**
     * @return OK
     */
    companyGetCompanyValues(body: GetCompanyValuesParameters): Observable<GetCompanyValuesResultType[]>;
    /**
     * @return OK
     */
    companyGetCompanyBoxesValues(body: GetCompanyValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    companyGetCompanyColumnChartValues(body: GetCompanyValuesParameters): Observable<GetCompanyColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    companyGetCompanyMetricsValues(body: GetCompanyValuesParameters): Observable<GetCompanyMetricsValuesResultType>;
    /**
     * @return OK
     */
    companyGetCompanyLineChartValues(body: GetCompanyValuesParameters): Observable<GetCompanyLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    companySearchBasicData(body: SearchCompaniesBasicDataParameters): Observable<SearchCompaniesBasicDataResultDto[]>;
    /**
     * @return OK
     */
    companySearchCompetingBiddersData(body: SearchCompaniesBasicDataParameters): Observable<SearchCompaniesBasicDataResultDto[]>;
    /**
     * @return OK
     */
    companyGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]>;
    /**
     * @return OK
     */
    companySaveCustomReport(body: CustomReportCompanyView): Observable<CustomReportCompanyView>;
    /**
     * @return OK
     */
    companySaveCatalogReport(body: CustomReportCompanyView): Observable<CustomReportCompanyView>;
    /**
     * @return OK
     */
    companyGetCustomReport(id: number): Observable<CustomReportCompanyView>;
    /**
     * @return OK
     */
    companyCreateSharedReport(body: CustomReportCompanyView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    companyGetSharedReport(id: string): Observable<CustomReportCompanyView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    companyResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class CompanyClient extends ReportingBaseClient implements ICompanyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    companyGetCompanyValues(body: GetCompanyValuesParameters): Observable<GetCompanyValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Company/company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyGetCompanyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyGetCompanyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompanyValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompanyValuesResultType[]>;
        }));
    }

    protected processCompanyGetCompanyValues(response: HttpResponseBase): Observable<GetCompanyValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCompanyValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyGetCompanyBoxesValues(body: GetCompanyValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/Company/company-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyGetCompanyBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyGetCompanyBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processCompanyGetCompanyBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyGetCompanyColumnChartValues(body: GetCompanyValuesParameters): Observable<GetCompanyColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Company/company-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyGetCompanyColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyGetCompanyColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompanyColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompanyColumnChartValuesResultType[]>;
        }));
    }

    protected processCompanyGetCompanyColumnChartValues(response: HttpResponseBase): Observable<GetCompanyColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCompanyColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyGetCompanyMetricsValues(body: GetCompanyValuesParameters): Observable<GetCompanyMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/Company/company-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyGetCompanyMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyGetCompanyMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompanyMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompanyMetricsValuesResultType>;
        }));
    }

    protected processCompanyGetCompanyMetricsValues(response: HttpResponseBase): Observable<GetCompanyMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCompanyMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyGetCompanyLineChartValues(body: GetCompanyValuesParameters): Observable<GetCompanyLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Company/company-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyGetCompanyLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyGetCompanyLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompanyLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompanyLineChartValuesResultType[]>;
        }));
    }

    protected processCompanyGetCompanyLineChartValues(response: HttpResponseBase): Observable<GetCompanyLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCompanyLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companySearchBasicData(body: SearchCompaniesBasicDataParameters): Observable<SearchCompaniesBasicDataResultDto[]> {
        let url_ = this.baseUrl + "/api/Company/basic-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySearchBasicData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySearchBasicData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCompaniesBasicDataResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCompaniesBasicDataResultDto[]>;
        }));
    }

    protected processCompanySearchBasicData(response: HttpResponseBase): Observable<SearchCompaniesBasicDataResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchCompaniesBasicDataResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companySearchCompetingBiddersData(body: SearchCompaniesBasicDataParameters): Observable<SearchCompaniesBasicDataResultDto[]> {
        let url_ = this.baseUrl + "/api/Company/competing-bidders-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySearchCompetingBiddersData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySearchCompetingBiddersData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCompaniesBasicDataResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCompaniesBasicDataResultDto[]>;
        }));
    }

    protected processCompanySearchCompetingBiddersData(response: HttpResponseBase): Observable<SearchCompaniesBasicDataResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchCompaniesBasicDataResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]> {
        let url_ = this.baseUrl + "/api/Company/custom-field-columns?";
        if (organizationIds === undefined || organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' must be defined and cannot be null.");
        else
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyGetCustomFieldColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyGetCustomFieldColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCustomFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCustomFieldDto[]>;
        }));
    }

    protected processCompanyGetCustomFieldColumns(response: HttpResponseBase): Observable<EntityTypeCustomFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCustomFieldDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companySaveCustomReport(body: CustomReportCompanyView): Observable<CustomReportCompanyView> {
        let url_ = this.baseUrl + "/api/Company/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportCompanyView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportCompanyView>;
        }));
    }

    protected processCompanySaveCustomReport(response: HttpResponseBase): Observable<CustomReportCompanyView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportCompanyView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companySaveCatalogReport(body: CustomReportCompanyView): Observable<CustomReportCompanyView> {
        let url_ = this.baseUrl + "/api/Company/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportCompanyView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportCompanyView>;
        }));
    }

    protected processCompanySaveCatalogReport(response: HttpResponseBase): Observable<CustomReportCompanyView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportCompanyView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyGetCustomReport(id: number): Observable<CustomReportCompanyView> {
        let url_ = this.baseUrl + "/api/Company/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportCompanyView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportCompanyView>;
        }));
    }

    protected processCompanyGetCustomReport(response: HttpResponseBase): Observable<CustomReportCompanyView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportCompanyView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyCreateSharedReport(body: CustomReportCompanyView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/Company/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processCompanyCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyGetSharedReport(id: string): Observable<CustomReportCompanyView> {
        let url_ = this.baseUrl + "/api/Company/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportCompanyView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportCompanyView>;
        }));
    }

    protected processCompanyGetSharedReport(response: HttpResponseBase): Observable<CustomReportCompanyView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportCompanyView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    companyResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/Company/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processCompanyResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompetingBiddersClient {
    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersValues(body: GetCompetingBiddersValuesParameters): Observable<GetCompetingBiddersValuesResultType[]>;
    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersMetricsValues(body: GetCompetingBiddersValuesParameters): Observable<GetCompetingBiddersMetricsValuesResultType>;
    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersBoxesValues(body: GetCompetingBiddersValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersLineChartValues(body: GetCompetingBiddersValuesParameters): Observable<GetCompetingBiddersLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersColumnChartValues(body: GetCompetingBiddersValuesParameters): Observable<GetCompetingBiddersColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    competingBiddersSaveCustomReport(body: CustomReportCompetingBiddersView): Observable<CustomReportCompetingBiddersView>;
    /**
     * @return OK
     */
    competingBiddersSaveCatalogReport(body: CustomReportCompetingBiddersView): Observable<CustomReportCompetingBiddersView>;
    /**
     * @return OK
     */
    competingBiddersGetCustomReport(id: number): Observable<CustomReportCompetingBiddersView>;
    /**
     * @return OK
     */
    competingBiddersCreateSharedReport(body: CustomReportCompetingBiddersView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    competingBiddersGetSharedReport(id: string): Observable<CustomReportCompetingBiddersView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    competingBiddersResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class CompetingBiddersClient extends ReportingBaseClient implements ICompetingBiddersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersValues(body: GetCompetingBiddersValuesParameters): Observable<GetCompetingBiddersValuesResultType[]> {
        let url_ = this.baseUrl + "/api/CompetingBidders/competing-bidders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersGetCompetingBiddersValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersGetCompetingBiddersValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompetingBiddersValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompetingBiddersValuesResultType[]>;
        }));
    }

    protected processCompetingBiddersGetCompetingBiddersValues(response: HttpResponseBase): Observable<GetCompetingBiddersValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCompetingBiddersValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersMetricsValues(body: GetCompetingBiddersValuesParameters): Observable<GetCompetingBiddersMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/CompetingBidders/competing-bidders-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersGetCompetingBiddersMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersGetCompetingBiddersMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompetingBiddersMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompetingBiddersMetricsValuesResultType>;
        }));
    }

    protected processCompetingBiddersGetCompetingBiddersMetricsValues(response: HttpResponseBase): Observable<GetCompetingBiddersMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCompetingBiddersMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersBoxesValues(body: GetCompetingBiddersValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/CompetingBidders/competing-bidders-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersGetCompetingBiddersBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersGetCompetingBiddersBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processCompetingBiddersGetCompetingBiddersBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersLineChartValues(body: GetCompetingBiddersValuesParameters): Observable<GetCompetingBiddersLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/CompetingBidders/competing-bidders-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersGetCompetingBiddersLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersGetCompetingBiddersLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompetingBiddersLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompetingBiddersLineChartValuesResultType[]>;
        }));
    }

    protected processCompetingBiddersGetCompetingBiddersLineChartValues(response: HttpResponseBase): Observable<GetCompetingBiddersLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCompetingBiddersLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    competingBiddersGetCompetingBiddersColumnChartValues(body: GetCompetingBiddersValuesParameters): Observable<GetCompetingBiddersColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/CompetingBidders/competing-bidders-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersGetCompetingBiddersColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersGetCompetingBiddersColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompetingBiddersColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompetingBiddersColumnChartValuesResultType[]>;
        }));
    }

    protected processCompetingBiddersGetCompetingBiddersColumnChartValues(response: HttpResponseBase): Observable<GetCompetingBiddersColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCompetingBiddersColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    competingBiddersSaveCustomReport(body: CustomReportCompetingBiddersView): Observable<CustomReportCompetingBiddersView> {
        let url_ = this.baseUrl + "/api/CompetingBidders/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportCompetingBiddersView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportCompetingBiddersView>;
        }));
    }

    protected processCompetingBiddersSaveCustomReport(response: HttpResponseBase): Observable<CustomReportCompetingBiddersView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportCompetingBiddersView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    competingBiddersSaveCatalogReport(body: CustomReportCompetingBiddersView): Observable<CustomReportCompetingBiddersView> {
        let url_ = this.baseUrl + "/api/CompetingBidders/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportCompetingBiddersView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportCompetingBiddersView>;
        }));
    }

    protected processCompetingBiddersSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportCompetingBiddersView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportCompetingBiddersView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    competingBiddersGetCustomReport(id: number): Observable<CustomReportCompetingBiddersView> {
        let url_ = this.baseUrl + "/api/CompetingBidders/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportCompetingBiddersView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportCompetingBiddersView>;
        }));
    }

    protected processCompetingBiddersGetCustomReport(response: HttpResponseBase): Observable<CustomReportCompetingBiddersView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportCompetingBiddersView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    competingBiddersCreateSharedReport(body: CustomReportCompetingBiddersView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/CompetingBidders/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processCompetingBiddersCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    competingBiddersGetSharedReport(id: string): Observable<CustomReportCompetingBiddersView> {
        let url_ = this.baseUrl + "/api/CompetingBidders/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportCompetingBiddersView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportCompetingBiddersView>;
        }));
    }

    protected processCompetingBiddersGetSharedReport(response: HttpResponseBase): Observable<CustomReportCompetingBiddersView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportCompetingBiddersView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    competingBiddersResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/CompetingBidders/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompetingBiddersResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompetingBiddersResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processCompetingBiddersResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IContactClient {
    /**
     * @return OK
     */
    contactSearchBasicData(body: SearchContactsBasicDataParameters): Observable<SearchContactsBasicDataResultDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ContactClient extends ReportingBaseClient implements IContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    contactSearchBasicData(body: SearchContactsBasicDataParameters): Observable<SearchContactsBasicDataResultDto[]> {
        let url_ = this.baseUrl + "/api/Contact/basic-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactSearchBasicData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactSearchBasicData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchContactsBasicDataResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchContactsBasicDataResultDto[]>;
        }));
    }

    protected processContactSearchBasicData(response: HttpResponseBase): Observable<SearchContactsBasicDataResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchContactsBasicDataResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomReportSearchClient {
    /**
     * @return OK
     */
    customReportSearchSearchCustomReports(body: SearchReportTemplateParameters): Observable<CustomReportView[]>;
    /**
     * @return OK
     */
    customReportSearchSearchCatalogReports(body: SearchReportTemplateParameters): Observable<CustomReportView[]>;
    /**
     * @return OK
     */
    customReportSearchDeactivate(id: number): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class CustomReportSearchClient extends ReportingBaseClient implements ICustomReportSearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    customReportSearchSearchCustomReports(body: SearchReportTemplateParameters): Observable<CustomReportView[]> {
        let url_ = this.baseUrl + "/api/CustomReportSearch/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomReportSearchSearchCustomReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomReportSearchSearchCustomReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportView[]>;
        }));
    }

    protected processCustomReportSearchSearchCustomReports(response: HttpResponseBase): Observable<CustomReportView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    customReportSearchSearchCatalogReports(body: SearchReportTemplateParameters): Observable<CustomReportView[]> {
        let url_ = this.baseUrl + "/api/CustomReportSearch/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomReportSearchSearchCatalogReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomReportSearchSearchCatalogReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportView[]>;
        }));
    }

    protected processCustomReportSearchSearchCatalogReports(response: HttpResponseBase): Observable<CustomReportView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    customReportSearchDeactivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/CustomReportSearch/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomReportSearchDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomReportSearchDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomReportSearchDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomReportUserFavoriteClient {
    /**
     * @return OK
     */
    customReportUserFavoriteToggleFavorite(id: number): Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class CustomReportUserFavoriteClient extends ReportingBaseClient implements ICustomReportUserFavoriteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    customReportUserFavoriteToggleFavorite(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/CustomReportUserFavorite/toggle/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomReportUserFavoriteToggleFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomReportUserFavoriteToggleFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCustomReportUserFavoriteToggleFavorite(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDivisionClient {
    /**
     * @return OK
     */
    divisionSearch(body: SearchDivisionsParameters): Observable<DivisionView[]>;
    /**
     * @return OK
     */
    divisionGetById(id: number): Observable<DivisionView>;
}

@Injectable({ providedIn: 'root' })
export class DivisionClient extends ReportingBaseClient implements IDivisionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    divisionSearch(body: SearchDivisionsParameters): Observable<DivisionView[]> {
        let url_ = this.baseUrl + "/api/Division/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDivisionSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDivisionSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivisionView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivisionView[]>;
        }));
    }

    protected processDivisionSearch(response: HttpResponseBase): Observable<DivisionView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DivisionView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    divisionGetById(id: number): Observable<DivisionView> {
        let url_ = this.baseUrl + "/api/Division/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDivisionGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDivisionGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivisionView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivisionView>;
        }));
    }

    protected processDivisionGetById(response: HttpResponseBase): Observable<DivisionView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DivisionView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEstimateClient {
    /**
     * @return OK
     */
    estimateGetEstimateValues(body: GetEstimateValuesParameters): Observable<GetEstimateValuesResultType[]>;
    /**
     * @return OK
     */
    estimateGetEstimateBoxesValues(body: GetEstimateValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    estimateGetEstimateColumnChartValues(body: GetEstimateValuesParameters): Observable<GetEstimateColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    estimateGetEstimateMetricsValues(body: GetEstimateValuesParameters): Observable<GetEstimateMetricsValuesResultType>;
    /**
     * @return OK
     */
    estimateGetEstimateLineChartValues(body: GetEstimateValuesParameters): Observable<GetEstimateLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    estimateSaveCustomReport(body: CustomReportEstimateView): Observable<CustomReportEstimateView>;
    /**
     * @return OK
     */
    estimateSaveCatalogReport(body: CustomReportEstimateView): Observable<CustomReportEstimateView>;
    /**
     * @return OK
     */
    estimateGetCustomReport(id: number): Observable<CustomReportEstimateView>;
    /**
     * @return OK
     */
    estimateCreateSharedReport(body: CustomReportEstimateView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    estimateGetSharedReport(id: string): Observable<CustomReportEstimateView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    estimateResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class EstimateClient extends ReportingBaseClient implements IEstimateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    estimateGetEstimateValues(body: GetEstimateValuesParameters): Observable<GetEstimateValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Estimate/estimate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateGetEstimateValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateGetEstimateValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEstimateValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEstimateValuesResultType[]>;
        }));
    }

    protected processEstimateGetEstimateValues(response: HttpResponseBase): Observable<GetEstimateValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEstimateValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateGetEstimateBoxesValues(body: GetEstimateValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/Estimate/estimate-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateGetEstimateBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateGetEstimateBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processEstimateGetEstimateBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateGetEstimateColumnChartValues(body: GetEstimateValuesParameters): Observable<GetEstimateColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Estimate/estimate-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateGetEstimateColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateGetEstimateColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEstimateColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEstimateColumnChartValuesResultType[]>;
        }));
    }

    protected processEstimateGetEstimateColumnChartValues(response: HttpResponseBase): Observable<GetEstimateColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEstimateColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateGetEstimateMetricsValues(body: GetEstimateValuesParameters): Observable<GetEstimateMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/Estimate/estimate-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateGetEstimateMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateGetEstimateMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEstimateMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEstimateMetricsValuesResultType>;
        }));
    }

    protected processEstimateGetEstimateMetricsValues(response: HttpResponseBase): Observable<GetEstimateMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEstimateMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateGetEstimateLineChartValues(body: GetEstimateValuesParameters): Observable<GetEstimateLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Estimate/estimate-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateGetEstimateLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateGetEstimateLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEstimateLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEstimateLineChartValuesResultType[]>;
        }));
    }

    protected processEstimateGetEstimateLineChartValues(response: HttpResponseBase): Observable<GetEstimateLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEstimateLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateSaveCustomReport(body: CustomReportEstimateView): Observable<CustomReportEstimateView> {
        let url_ = this.baseUrl + "/api/Estimate/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportEstimateView>;
        }));
    }

    protected processEstimateSaveCustomReport(response: HttpResponseBase): Observable<CustomReportEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateSaveCatalogReport(body: CustomReportEstimateView): Observable<CustomReportEstimateView> {
        let url_ = this.baseUrl + "/api/Estimate/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportEstimateView>;
        }));
    }

    protected processEstimateSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateGetCustomReport(id: number): Observable<CustomReportEstimateView> {
        let url_ = this.baseUrl + "/api/Estimate/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportEstimateView>;
        }));
    }

    protected processEstimateGetCustomReport(response: HttpResponseBase): Observable<CustomReportEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateCreateSharedReport(body: CustomReportEstimateView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/Estimate/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processEstimateCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateGetSharedReport(id: string): Observable<CustomReportEstimateView> {
        let url_ = this.baseUrl + "/api/Estimate/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportEstimateView>;
        }));
    }

    protected processEstimateGetSharedReport(response: HttpResponseBase): Observable<CustomReportEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    estimateResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/Estimate/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processEstimateResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFinalEstimatesClient {
    /**
     * @return OK
     */
    finalEstimatesGetAwardedFinalEstimatesValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<GetExternalAwardedFinalEstimatesValuesResultType[]>;
    /**
     * @return OK
     */
    finalEstimatesGetAwardedFinalEstimatesBoxesValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    finalEstimatesGetAwardedFinalEstimatesMetricsValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<GetAwardedFinalEstimatesMetricsValuesResultType>;
    /**
     * @return OK
     */
    finalEstimatesGetFinalEstimatesLineChartValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<GetFinalEstimatesLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    finalEstimatesGetFinalEstimatesColumnChartValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<GetFinalEstimatesColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    finalEstimatesSaveCustomReport(body: CustomReportAwardedFinalEstimateView): Observable<CustomReportAwardedFinalEstimateView>;
    /**
     * @return OK
     */
    finalEstimatesSaveCatalogReport(body: CustomReportAwardedFinalEstimateView): Observable<CustomReportAwardedFinalEstimateView>;
    /**
     * @return OK
     */
    finalEstimatesGetCustomReport(id: number): Observable<CustomReportAwardedFinalEstimateView>;
    /**
     * @return OK
     */
    finalEstimatesCreateSharedReport(body: CustomReportAwardedFinalEstimateView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    finalEstimatesGetSharedReport(id: string): Observable<CustomReportAwardedFinalEstimateView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    finalEstimatesResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class FinalEstimatesClient extends ReportingBaseClient implements IFinalEstimatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    finalEstimatesGetAwardedFinalEstimatesValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<GetExternalAwardedFinalEstimatesValuesResultType[]> {
        let url_ = this.baseUrl + "/api/FinalEstimates/final-estimates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesGetAwardedFinalEstimatesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesGetAwardedFinalEstimatesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExternalAwardedFinalEstimatesValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExternalAwardedFinalEstimatesValuesResultType[]>;
        }));
    }

    protected processFinalEstimatesGetAwardedFinalEstimatesValues(response: HttpResponseBase): Observable<GetExternalAwardedFinalEstimatesValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetExternalAwardedFinalEstimatesValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finalEstimatesGetAwardedFinalEstimatesBoxesValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/FinalEstimates/final-estimates-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesGetAwardedFinalEstimatesBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesGetAwardedFinalEstimatesBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processFinalEstimatesGetAwardedFinalEstimatesBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finalEstimatesGetAwardedFinalEstimatesMetricsValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<GetAwardedFinalEstimatesMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/FinalEstimates/final-estimates-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesGetAwardedFinalEstimatesMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesGetAwardedFinalEstimatesMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAwardedFinalEstimatesMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAwardedFinalEstimatesMetricsValuesResultType>;
        }));
    }

    protected processFinalEstimatesGetAwardedFinalEstimatesMetricsValues(response: HttpResponseBase): Observable<GetAwardedFinalEstimatesMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAwardedFinalEstimatesMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finalEstimatesGetFinalEstimatesLineChartValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<GetFinalEstimatesLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/FinalEstimates/final-estimates-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesGetFinalEstimatesLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesGetFinalEstimatesLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFinalEstimatesLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFinalEstimatesLineChartValuesResultType[]>;
        }));
    }

    protected processFinalEstimatesGetFinalEstimatesLineChartValues(response: HttpResponseBase): Observable<GetFinalEstimatesLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetFinalEstimatesLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finalEstimatesGetFinalEstimatesColumnChartValues(body: GetAwardedFinalEstimatesValuesParameters): Observable<GetFinalEstimatesColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/FinalEstimates/final-estimates-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesGetFinalEstimatesColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesGetFinalEstimatesColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFinalEstimatesColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFinalEstimatesColumnChartValuesResultType[]>;
        }));
    }

    protected processFinalEstimatesGetFinalEstimatesColumnChartValues(response: HttpResponseBase): Observable<GetFinalEstimatesColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetFinalEstimatesColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finalEstimatesSaveCustomReport(body: CustomReportAwardedFinalEstimateView): Observable<CustomReportAwardedFinalEstimateView> {
        let url_ = this.baseUrl + "/api/FinalEstimates/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAwardedFinalEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAwardedFinalEstimateView>;
        }));
    }

    protected processFinalEstimatesSaveCustomReport(response: HttpResponseBase): Observable<CustomReportAwardedFinalEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAwardedFinalEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finalEstimatesSaveCatalogReport(body: CustomReportAwardedFinalEstimateView): Observable<CustomReportAwardedFinalEstimateView> {
        let url_ = this.baseUrl + "/api/FinalEstimates/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAwardedFinalEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAwardedFinalEstimateView>;
        }));
    }

    protected processFinalEstimatesSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportAwardedFinalEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAwardedFinalEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finalEstimatesGetCustomReport(id: number): Observable<CustomReportAwardedFinalEstimateView> {
        let url_ = this.baseUrl + "/api/FinalEstimates/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAwardedFinalEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAwardedFinalEstimateView>;
        }));
    }

    protected processFinalEstimatesGetCustomReport(response: HttpResponseBase): Observable<CustomReportAwardedFinalEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAwardedFinalEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finalEstimatesCreateSharedReport(body: CustomReportAwardedFinalEstimateView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/FinalEstimates/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processFinalEstimatesCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finalEstimatesGetSharedReport(id: string): Observable<CustomReportAwardedFinalEstimateView> {
        let url_ = this.baseUrl + "/api/FinalEstimates/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportAwardedFinalEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportAwardedFinalEstimateView>;
        }));
    }

    protected processFinalEstimatesGetSharedReport(response: HttpResponseBase): Observable<CustomReportAwardedFinalEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportAwardedFinalEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    finalEstimatesResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/FinalEstimates/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalEstimatesResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalEstimatesResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processFinalEstimatesResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILeadClient {
    /**
     * @return OK
     */
    leadGetById(id: number): Observable<LeadDto>;
    /**
     * @return OK
     */
    leadGetAll(): Observable<LeadDto[]>;
    /**
     * @return OK
     */
    leadGetByIds(ids: number[]): Observable<LeadDto[]>;
}

@Injectable({ providedIn: 'root' })
export class LeadClient extends ReportingBaseClient implements ILeadClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    leadGetById(id: number): Observable<LeadDto> {
        let url_ = this.baseUrl + "/api/Lead/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeadGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeadGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadDto>;
        }));
    }

    protected processLeadGetById(response: HttpResponseBase): Observable<LeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    leadGetAll(): Observable<LeadDto[]> {
        let url_ = this.baseUrl + "/api/Lead/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeadGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeadGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadDto[]>;
        }));
    }

    protected processLeadGetAll(response: HttpResponseBase): Observable<LeadDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeadDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    leadGetByIds(ids: number[]): Observable<LeadDto[]> {
        let url_ = this.baseUrl + "/api/Lead/search?";
        if (ids === undefined || ids === null)
            throw new globalThis.Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeadGetByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeadGetByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadDto[]>;
        }));
    }

    protected processLeadGetByIds(response: HttpResponseBase): Observable<LeadDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeadDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMarketClient {
    /**
     * @return OK
     */
    marketGetById(id: number): Observable<MarketDto>;
    /**
     * @return OK
     */
    marketGetAll(): Observable<MarketDto[]>;
    /**
     * @return OK
     */
    marketGetByIds(ids: number[]): Observable<MarketDto[]>;
}

@Injectable({ providedIn: 'root' })
export class MarketClient extends ReportingBaseClient implements IMarketClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    marketGetById(id: number): Observable<MarketDto> {
        let url_ = this.baseUrl + "/api/Market/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarketGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketDto>;
        }));
    }

    protected processMarketGetById(response: HttpResponseBase): Observable<MarketDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    marketGetAll(): Observable<MarketDto[]> {
        let url_ = this.baseUrl + "/api/Market/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarketGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketDto[]>;
        }));
    }

    protected processMarketGetAll(response: HttpResponseBase): Observable<MarketDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    marketGetByIds(ids: number[]): Observable<MarketDto[]> {
        let url_ = this.baseUrl + "/api/Market/search?";
        if (ids === undefined || ids === null)
            throw new globalThis.Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarketGetByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketGetByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketDto[]>;
        }));
    }

    protected processMarketGetByIds(response: HttpResponseBase): Observable<MarketDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityClient {
    /**
     * @return OK
     */
    opportunityGetOpportunityValues(body: GetOpportunityValuesParameters): Observable<GetOpportunityValuesResultType[]>;
    /**
     * @return OK
     */
    opportunityGetOpportunityMetricsValues(body: GetOpportunityValuesParameters): Observable<GetOpportunityMetricsValuesResultType>;
    /**
     * @return OK
     */
    opportunityGetOpportunityBoxesValues(body: GetOpportunityValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    opportunityGetOpportunityColumnChartValues(body: GetOpportunityValuesParameters): Observable<GetOpportunityColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    opportunityGetOpportunityLineChartValues(body: GetOpportunityValuesParameters): Observable<GetOpportunityLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    opportunityQuickSearch(body: QuickSearchOpportunitiesParameters): Observable<OpportunityQuickSearchResultDto[]>;
    /**
     * @return OK
     */
    opportunityGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]>;
    /**
     * @return OK
     */
    opportunitySaveCustomReport(body: CustomReportOpportunityView): Observable<CustomReportOpportunityView>;
    /**
     * @return OK
     */
    opportunitySaveCatalogReport(body: CustomReportOpportunityView): Observable<CustomReportOpportunityView>;
    /**
     * @return OK
     */
    opportunityGetCustomReport(id: number): Observable<CustomReportOpportunityView>;
    /**
     * @return OK
     */
    opportunityCreateSharedReport(body: CustomReportOpportunityView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    opportunityGetSharedReport(id: string): Observable<CustomReportOpportunityView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    opportunityResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityClient extends ReportingBaseClient implements IOpportunityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityGetOpportunityValues(body: GetOpportunityValuesParameters): Observable<GetOpportunityValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Opportunity/opportunity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetOpportunityValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetOpportunityValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOpportunityValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOpportunityValuesResultType[]>;
        }));
    }

    protected processOpportunityGetOpportunityValues(response: HttpResponseBase): Observable<GetOpportunityValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOpportunityValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityGetOpportunityMetricsValues(body: GetOpportunityValuesParameters): Observable<GetOpportunityMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/Opportunity/opportunity-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetOpportunityMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetOpportunityMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOpportunityMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOpportunityMetricsValuesResultType>;
        }));
    }

    protected processOpportunityGetOpportunityMetricsValues(response: HttpResponseBase): Observable<GetOpportunityMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOpportunityMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityGetOpportunityBoxesValues(body: GetOpportunityValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/Opportunity/opportunity-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetOpportunityBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetOpportunityBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processOpportunityGetOpportunityBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityGetOpportunityColumnChartValues(body: GetOpportunityValuesParameters): Observable<GetOpportunityColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Opportunity/opportunity-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetOpportunityColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetOpportunityColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOpportunityColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOpportunityColumnChartValuesResultType[]>;
        }));
    }

    protected processOpportunityGetOpportunityColumnChartValues(response: HttpResponseBase): Observable<GetOpportunityColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOpportunityColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityGetOpportunityLineChartValues(body: GetOpportunityValuesParameters): Observable<GetOpportunityLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/Opportunity/opportunity-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetOpportunityLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetOpportunityLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOpportunityLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOpportunityLineChartValuesResultType[]>;
        }));
    }

    protected processOpportunityGetOpportunityLineChartValues(response: HttpResponseBase): Observable<GetOpportunityLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOpportunityLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityQuickSearch(body: QuickSearchOpportunitiesParameters): Observable<OpportunityQuickSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/Opportunity/quick-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityQuickSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityQuickSearchResultDto[]>;
        }));
    }

    protected processOpportunityQuickSearch(response: HttpResponseBase): Observable<OpportunityQuickSearchResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityQuickSearchResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]> {
        let url_ = this.baseUrl + "/api/Opportunity/custom-field-columns?";
        if (organizationIds === undefined || organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' must be defined and cannot be null.");
        else
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetCustomFieldColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetCustomFieldColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCustomFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCustomFieldDto[]>;
        }));
    }

    protected processOpportunityGetCustomFieldColumns(response: HttpResponseBase): Observable<EntityTypeCustomFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCustomFieldDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySaveCustomReport(body: CustomReportOpportunityView): Observable<CustomReportOpportunityView> {
        let url_ = this.baseUrl + "/api/Opportunity/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportOpportunityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportOpportunityView>;
        }));
    }

    protected processOpportunitySaveCustomReport(response: HttpResponseBase): Observable<CustomReportOpportunityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportOpportunityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySaveCatalogReport(body: CustomReportOpportunityView): Observable<CustomReportOpportunityView> {
        let url_ = this.baseUrl + "/api/Opportunity/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportOpportunityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportOpportunityView>;
        }));
    }

    protected processOpportunitySaveCatalogReport(response: HttpResponseBase): Observable<CustomReportOpportunityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportOpportunityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityGetCustomReport(id: number): Observable<CustomReportOpportunityView> {
        let url_ = this.baseUrl + "/api/Opportunity/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportOpportunityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportOpportunityView>;
        }));
    }

    protected processOpportunityGetCustomReport(response: HttpResponseBase): Observable<CustomReportOpportunityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportOpportunityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityCreateSharedReport(body: CustomReportOpportunityView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/Opportunity/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processOpportunityCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityGetSharedReport(id: string): Observable<CustomReportOpportunityView> {
        let url_ = this.baseUrl + "/api/Opportunity/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportOpportunityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportOpportunityView>;
        }));
    }

    protected processOpportunityGetSharedReport(response: HttpResponseBase): Observable<CustomReportOpportunityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportOpportunityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    opportunityResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/Opportunity/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processOpportunityResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOrganizationClient {
    /**
     * @return OK
     */
    organizationGetForCurrentUser(): Observable<OrganizationDto[]>;
    /**
     * @return OK
     */
    organizationGetManagedOrganizationsForUser(): Observable<OrganizationDto[]>;
}

@Injectable({ providedIn: 'root' })
export class OrganizationClient extends ReportingBaseClient implements IOrganizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    organizationGetForCurrentUser(): Observable<OrganizationDto[]> {
        let url_ = this.baseUrl + "/api/Organization/user-organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrganizationGetForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrganizationGetForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationDto[]>;
        }));
    }

    protected processOrganizationGetForCurrentUser(response: HttpResponseBase): Observable<OrganizationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganizationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    organizationGetManagedOrganizationsForUser(): Observable<OrganizationDto[]> {
        let url_ = this.baseUrl + "/api/Organization/user-managed-organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrganizationGetManagedOrganizationsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrganizationGetManagedOrganizationsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationDto[]>;
        }));
    }

    protected processOrganizationGetManagedOrganizationsForUser(response: HttpResponseBase): Observable<OrganizationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganizationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPointListSystemsClient {
    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemValues(body: GetDataFilterValuesParameters): Observable<GetPointsListSystemValuesResultType[]>;
    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemMetricsValues(body: GetDataFilterValuesParameters): Observable<GetPointsListSystemMetricsValuesResultType>;
    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemLineChartValues(body: GetDataFilterValuesParameters): Observable<GetPointsListSystemLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemClusterChartValues(body: GetDataFilterValuesParameters): Observable<GetPointsListSystemClusterChartValuesResultType[]>;
    /**
     * @return OK
     */
    pointListSystemsSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    pointListSystemsSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    pointListSystemsGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    pointListSystemsCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    pointListSystemsGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    pointListSystemsResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class PointListSystemsClient extends ReportingBaseClient implements IPointListSystemsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemValues(body: GetDataFilterValuesParameters): Observable<GetPointsListSystemValuesResultType[]> {
        let url_ = this.baseUrl + "/api/PointListSystems/pointlist-systems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsGetPointsListSystemValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsGetPointsListSystemValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPointsListSystemValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPointsListSystemValuesResultType[]>;
        }));
    }

    protected processPointListSystemsGetPointsListSystemValues(response: HttpResponseBase): Observable<GetPointsListSystemValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPointsListSystemValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemMetricsValues(body: GetDataFilterValuesParameters): Observable<GetPointsListSystemMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/PointListSystems/pointlist-systems-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsGetPointsListSystemMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsGetPointsListSystemMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPointsListSystemMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPointsListSystemMetricsValuesResultType>;
        }));
    }

    protected processPointListSystemsGetPointsListSystemMetricsValues(response: HttpResponseBase): Observable<GetPointsListSystemMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPointsListSystemMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/PointListSystems/pointlist-systems-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsGetPointsListSystemBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsGetPointsListSystemBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processPointListSystemsGetPointsListSystemBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemLineChartValues(body: GetDataFilterValuesParameters): Observable<GetPointsListSystemLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/PointListSystems/pointlist-systems-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsGetPointsListSystemLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsGetPointsListSystemLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPointsListSystemLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPointsListSystemLineChartValuesResultType[]>;
        }));
    }

    protected processPointListSystemsGetPointsListSystemLineChartValues(response: HttpResponseBase): Observable<GetPointsListSystemLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPointsListSystemLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pointListSystemsGetPointsListSystemClusterChartValues(body: GetDataFilterValuesParameters): Observable<GetPointsListSystemClusterChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/PointListSystems/pointlist-systems-cluster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsGetPointsListSystemClusterChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsGetPointsListSystemClusterChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPointsListSystemClusterChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPointsListSystemClusterChartValuesResultType[]>;
        }));
    }

    protected processPointListSystemsGetPointsListSystemClusterChartValues(response: HttpResponseBase): Observable<GetPointsListSystemClusterChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPointsListSystemClusterChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pointListSystemsSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/PointListSystems/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processPointListSystemsSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pointListSystemsSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/PointListSystems/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processPointListSystemsSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pointListSystemsGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/PointListSystems/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processPointListSystemsGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pointListSystemsCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/PointListSystems/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processPointListSystemsCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pointListSystemsGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/PointListSystems/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processPointListSystemsGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    pointListSystemsResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/PointListSystems/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPointListSystemsResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPointListSystemsResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processPointListSystemsResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectCustomClient {
    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleCustomValuesResultType[]>;
    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleCustomMetricsValuesResultType>;
    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleCustomLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleCustomColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectCustomSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectCustomSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectCustomGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectCustomCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    projectCustomGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectCustomResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ProjectCustomClient extends ReportingBaseClient implements IProjectCustomClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleCustomValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectCustom/project-custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomGetProjectModuleCustomValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomGetProjectModuleCustomValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleCustomValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleCustomValuesResultType[]>;
        }));
    }

    protected processProjectCustomGetProjectModuleCustomValues(response: HttpResponseBase): Observable<GetProjectModuleCustomValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleCustomValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleCustomMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ProjectCustom/project-custom-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomGetProjectModuleCustomMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomGetProjectModuleCustomMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleCustomMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleCustomMetricsValuesResultType>;
        }));
    }

    protected processProjectCustomGetProjectModuleCustomMetricsValues(response: HttpResponseBase): Observable<GetProjectModuleCustomMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleCustomMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectCustom/project-custom-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomGetProjectModuleCustomBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomGetProjectModuleCustomBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processProjectCustomGetProjectModuleCustomBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleCustomLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectCustom/project-custom-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomGetProjectModuleCustomLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomGetProjectModuleCustomLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleCustomLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleCustomLineChartValuesResultType[]>;
        }));
    }

    protected processProjectCustomGetProjectModuleCustomLineChartValues(response: HttpResponseBase): Observable<GetProjectModuleCustomLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleCustomLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectCustomGetProjectModuleCustomColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleCustomColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectCustom/project-custom-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomGetProjectModuleCustomColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomGetProjectModuleCustomColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleCustomColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleCustomColumnChartValuesResultType[]>;
        }));
    }

    protected processProjectCustomGetProjectModuleCustomColumnChartValues(response: HttpResponseBase): Observable<GetProjectModuleCustomColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleCustomColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectCustomSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectCustom/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectCustomSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectCustomSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectCustom/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectCustomSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectCustomGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectCustom/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectCustomGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectCustomCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ProjectCustom/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processProjectCustomCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectCustomGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectCustom/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectCustomGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectCustomResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ProjectCustom/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCustomResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCustomResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processProjectCustomResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectExpensesClient {
    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleExpensesValuesResultType[]>;
    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleExpensesMetricsValuesResultType>;
    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleExpensesLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleExpensesColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectExpensesSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectExpensesSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectExpensesGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectExpensesCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    projectExpensesGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectExpensesResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ProjectExpensesClient extends ReportingBaseClient implements IProjectExpensesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleExpensesValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/project-expenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesGetProjectModuleExpensesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesGetProjectModuleExpensesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleExpensesValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleExpensesValuesResultType[]>;
        }));
    }

    protected processProjectExpensesGetProjectModuleExpensesValues(response: HttpResponseBase): Observable<GetProjectModuleExpensesValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleExpensesValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleExpensesMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/project-expenses-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesGetProjectModuleExpensesMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesGetProjectModuleExpensesMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleExpensesMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleExpensesMetricsValuesResultType>;
        }));
    }

    protected processProjectExpensesGetProjectModuleExpensesMetricsValues(response: HttpResponseBase): Observable<GetProjectModuleExpensesMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleExpensesMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/project-expenses-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesGetProjectModuleExpensesBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesGetProjectModuleExpensesBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processProjectExpensesGetProjectModuleExpensesBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleExpensesLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/project-expenses-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesGetProjectModuleExpensesLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesGetProjectModuleExpensesLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleExpensesLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleExpensesLineChartValuesResultType[]>;
        }));
    }

    protected processProjectExpensesGetProjectModuleExpensesLineChartValues(response: HttpResponseBase): Observable<GetProjectModuleExpensesLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleExpensesLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectExpensesGetProjectModuleExpensesColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleExpensesColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/project-expenses-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesGetProjectModuleExpensesColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesGetProjectModuleExpensesColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleExpensesColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleExpensesColumnChartValuesResultType[]>;
        }));
    }

    protected processProjectExpensesGetProjectModuleExpensesColumnChartValues(response: HttpResponseBase): Observable<GetProjectModuleExpensesColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleExpensesColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectExpensesSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectExpensesSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectExpensesSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectExpensesSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectExpensesGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectExpensesGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectExpensesCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processProjectExpensesCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectExpensesGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectExpensesGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectExpensesResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ProjectExpenses/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectExpensesResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectExpensesResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processProjectExpensesResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectLaborRoleClient {
    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborRoleValuesResultType[]>;
    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborRoleMetricsValuesResultType>;
    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborRoleLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborRoleColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectLaborRoleSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectLaborRoleSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectLaborRoleGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectLaborRoleCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    projectLaborRoleGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectLaborRoleResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ProjectLaborRoleClient extends ReportingBaseClient implements IProjectLaborRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborRoleValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/project-labor-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleGetProjectModuleLaborRoleValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleGetProjectModuleLaborRoleValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleLaborRoleValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleLaborRoleValuesResultType[]>;
        }));
    }

    protected processProjectLaborRoleGetProjectModuleLaborRoleValues(response: HttpResponseBase): Observable<GetProjectModuleLaborRoleValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleLaborRoleValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/project-labor-role-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleGetProjectModuleLaborRoleBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleGetProjectModuleLaborRoleBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processProjectLaborRoleGetProjectModuleLaborRoleBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborRoleMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/project-labor-role-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleGetProjectModuleLaborRoleMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleGetProjectModuleLaborRoleMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleLaborRoleMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleLaborRoleMetricsValuesResultType>;
        }));
    }

    protected processProjectLaborRoleGetProjectModuleLaborRoleMetricsValues(response: HttpResponseBase): Observable<GetProjectModuleLaborRoleMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleLaborRoleMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborRoleLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/project-labor-role-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleGetProjectModuleLaborRoleLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleGetProjectModuleLaborRoleLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleLaborRoleLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleLaborRoleLineChartValuesResultType[]>;
        }));
    }

    protected processProjectLaborRoleGetProjectModuleLaborRoleLineChartValues(response: HttpResponseBase): Observable<GetProjectModuleLaborRoleLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleLaborRoleLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborRoleGetProjectModuleLaborRoleColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborRoleColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/project-labor-role-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleGetProjectModuleLaborRoleColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleGetProjectModuleLaborRoleColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleLaborRoleColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleLaborRoleColumnChartValuesResultType[]>;
        }));
    }

    protected processProjectLaborRoleGetProjectModuleLaborRoleColumnChartValues(response: HttpResponseBase): Observable<GetProjectModuleLaborRoleColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleLaborRoleColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborRoleSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectLaborRoleSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborRoleSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectLaborRoleSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborRoleGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectLaborRoleGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborRoleCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processProjectLaborRoleCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborRoleGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectLaborRoleGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectLaborRoleResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborRole/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborRoleResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborRoleResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processProjectLaborRoleResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectLaborTaskClient {
    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborTaskValuesResultType[]>;
    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborTaskMetricsValuesResultType>;
    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborTaskLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborTaskColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectLaborTaskSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectLaborTaskSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectLaborTaskGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectLaborTaskCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    projectLaborTaskGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectLaborTaskResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ProjectLaborTaskClient extends ReportingBaseClient implements IProjectLaborTaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborTaskValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/project-labor-task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskGetProjectModuleLaborTaskValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskGetProjectModuleLaborTaskValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleLaborTaskValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleLaborTaskValuesResultType[]>;
        }));
    }

    protected processProjectLaborTaskGetProjectModuleLaborTaskValues(response: HttpResponseBase): Observable<GetProjectModuleLaborTaskValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleLaborTaskValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/project-labor-task-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskGetProjectModuleLaborTaskBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskGetProjectModuleLaborTaskBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processProjectLaborTaskGetProjectModuleLaborTaskBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborTaskMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/project-labor-task-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskGetProjectModuleLaborTaskMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskGetProjectModuleLaborTaskMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleLaborTaskMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleLaborTaskMetricsValuesResultType>;
        }));
    }

    protected processProjectLaborTaskGetProjectModuleLaborTaskMetricsValues(response: HttpResponseBase): Observable<GetProjectModuleLaborTaskMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleLaborTaskMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborTaskLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/project-labor-task-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskGetProjectModuleLaborTaskLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskGetProjectModuleLaborTaskLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleLaborTaskLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleLaborTaskLineChartValuesResultType[]>;
        }));
    }

    protected processProjectLaborTaskGetProjectModuleLaborTaskLineChartValues(response: HttpResponseBase): Observable<GetProjectModuleLaborTaskLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleLaborTaskLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborTaskGetProjectModuleLaborTaskColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLaborTaskColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/project-labor-task-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskGetProjectModuleLaborTaskColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskGetProjectModuleLaborTaskColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleLaborTaskColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleLaborTaskColumnChartValuesResultType[]>;
        }));
    }

    protected processProjectLaborTaskGetProjectModuleLaborTaskColumnChartValues(response: HttpResponseBase): Observable<GetProjectModuleLaborTaskColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleLaborTaskColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborTaskSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectLaborTaskSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborTaskSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectLaborTaskSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborTaskGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectLaborTaskGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborTaskCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processProjectLaborTaskCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectLaborTaskGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectLaborTaskGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectLaborTaskResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ProjectLaborTask/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectLaborTaskResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectLaborTaskResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processProjectLaborTaskResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectMaterialClient {
    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetProjectModuleMaterialValuesResultType[]>;
    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialBoxesValues(body: GetDataFilterValuesParametersForNonStandard): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialMetricsValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetProjectModuleMaterialMetricsValuesResultType>;
    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialLineChartValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetProjectModuleMaterialLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialColumnChartValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetProjectModuleMaterialColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectMaterialSaveCustomReport(body: CustomReportModuleMaterialView): Observable<CustomReportModuleMaterialView>;
    /**
     * @return OK
     */
    projectMaterialSaveCatalogReport(body: CustomReportModuleMaterialView): Observable<CustomReportModuleMaterialView>;
    /**
     * @return OK
     */
    projectMaterialGetCustomReport(id: number): Observable<CustomReportModuleMaterialView>;
    /**
     * @return OK
     */
    projectMaterialCreateSharedReport(body: CustomReportModuleMaterialView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    projectMaterialGetSharedReport(id: string): Observable<CustomReportModuleMaterialView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectMaterialResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ProjectMaterialClient extends ReportingBaseClient implements IProjectMaterialClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetProjectModuleMaterialValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/project-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGetProjectModuleMaterialValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGetProjectModuleMaterialValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleMaterialValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleMaterialValuesResultType[]>;
        }));
    }

    protected processProjectMaterialGetProjectModuleMaterialValues(response: HttpResponseBase): Observable<GetProjectModuleMaterialValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleMaterialValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialBoxesValues(body: GetDataFilterValuesParametersForNonStandard): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/project-material-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGetProjectModuleMaterialBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGetProjectModuleMaterialBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processProjectMaterialGetProjectModuleMaterialBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialMetricsValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetProjectModuleMaterialMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/project-material-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGetProjectModuleMaterialMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGetProjectModuleMaterialMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleMaterialMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleMaterialMetricsValuesResultType>;
        }));
    }

    protected processProjectMaterialGetProjectModuleMaterialMetricsValues(response: HttpResponseBase): Observable<GetProjectModuleMaterialMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleMaterialMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialLineChartValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetProjectModuleMaterialLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/project-material-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGetProjectModuleMaterialLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGetProjectModuleMaterialLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleMaterialLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleMaterialLineChartValuesResultType[]>;
        }));
    }

    protected processProjectMaterialGetProjectModuleMaterialLineChartValues(response: HttpResponseBase): Observable<GetProjectModuleMaterialLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleMaterialLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGetProjectModuleMaterialColumnChartValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetProjectModuleMaterialColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/project-material-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGetProjectModuleMaterialColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGetProjectModuleMaterialColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleMaterialColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleMaterialColumnChartValuesResultType[]>;
        }));
    }

    protected processProjectMaterialGetProjectModuleMaterialColumnChartValues(response: HttpResponseBase): Observable<GetProjectModuleMaterialColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleMaterialColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialSaveCustomReport(body: CustomReportModuleMaterialView): Observable<CustomReportModuleMaterialView> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportModuleMaterialView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportModuleMaterialView>;
        }));
    }

    protected processProjectMaterialSaveCustomReport(response: HttpResponseBase): Observable<CustomReportModuleMaterialView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportModuleMaterialView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialSaveCatalogReport(body: CustomReportModuleMaterialView): Observable<CustomReportModuleMaterialView> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportModuleMaterialView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportModuleMaterialView>;
        }));
    }

    protected processProjectMaterialSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportModuleMaterialView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportModuleMaterialView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGetCustomReport(id: number): Observable<CustomReportModuleMaterialView> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportModuleMaterialView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportModuleMaterialView>;
        }));
    }

    protected processProjectMaterialGetCustomReport(response: HttpResponseBase): Observable<CustomReportModuleMaterialView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportModuleMaterialView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialCreateSharedReport(body: CustomReportModuleMaterialView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processProjectMaterialCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGetSharedReport(id: string): Observable<CustomReportModuleMaterialView> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportModuleMaterialView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportModuleMaterialView>;
        }));
    }

    protected processProjectMaterialGetSharedReport(response: HttpResponseBase): Observable<CustomReportModuleMaterialView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportModuleMaterialView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectMaterialResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterial/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processProjectMaterialResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectMaterialGroupClient {
    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMaterialGroupValuesResultType[]>;
    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMaterialGroupMetricsValuesResultType>;
    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMaterialGroupLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMaterialGroupColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectMaterialGroupSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectMaterialGroupSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectMaterialGroupGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectMaterialGroupCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    projectMaterialGroupGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectMaterialGroupResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ProjectMaterialGroupClient extends ReportingBaseClient implements IProjectMaterialGroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMaterialGroupValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/project-material-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupGetProjectModuleMaterialGroupValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupGetProjectModuleMaterialGroupValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleMaterialGroupValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleMaterialGroupValuesResultType[]>;
        }));
    }

    protected processProjectMaterialGroupGetProjectModuleMaterialGroupValues(response: HttpResponseBase): Observable<GetProjectModuleMaterialGroupValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleMaterialGroupValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/project-material-group-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupGetProjectModuleMaterialGroupBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupGetProjectModuleMaterialGroupBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processProjectMaterialGroupGetProjectModuleMaterialGroupBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMaterialGroupMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/project-material-group-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupGetProjectModuleMaterialGroupMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupGetProjectModuleMaterialGroupMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleMaterialGroupMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleMaterialGroupMetricsValuesResultType>;
        }));
    }

    protected processProjectMaterialGroupGetProjectModuleMaterialGroupMetricsValues(response: HttpResponseBase): Observable<GetProjectModuleMaterialGroupMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleMaterialGroupMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMaterialGroupLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/project-material-group-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupGetProjectModuleMaterialGroupLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupGetProjectModuleMaterialGroupLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleMaterialGroupLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleMaterialGroupLineChartValuesResultType[]>;
        }));
    }

    protected processProjectMaterialGroupGetProjectModuleMaterialGroupLineChartValues(response: HttpResponseBase): Observable<GetProjectModuleMaterialGroupLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleMaterialGroupLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGroupGetProjectModuleMaterialGroupColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMaterialGroupColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/project-material-group-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupGetProjectModuleMaterialGroupColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupGetProjectModuleMaterialGroupColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleMaterialGroupColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleMaterialGroupColumnChartValuesResultType[]>;
        }));
    }

    protected processProjectMaterialGroupGetProjectModuleMaterialGroupColumnChartValues(response: HttpResponseBase): Observable<GetProjectModuleMaterialGroupColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleMaterialGroupColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGroupSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectMaterialGroupSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGroupSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectMaterialGroupSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGroupGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectMaterialGroupGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGroupCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processProjectMaterialGroupCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectMaterialGroupGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectMaterialGroupGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectMaterialGroupResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ProjectMaterialGroup/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaterialGroupResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaterialGroupResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processProjectMaterialGroupResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectModuleClient {
    /**
     * @return OK
     */
    projectModuleGetProjectModuleCustomValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleValuesResultType[]>;
    /**
     * @return OK
     */
    projectModuleGetProjectModuleCustomMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMetricsValuesResultType>;
    /**
     * @return OK
     */
    projectModuleGetProjectModuleBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    projectModuleGetProjectModuleLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectModuleGetProjectModuleColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectModuleSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectModuleSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectModuleGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectModuleCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    projectModuleGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectModuleResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ProjectModuleClient extends ReportingBaseClient implements IProjectModuleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    projectModuleGetProjectModuleCustomValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectModule/project-module";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleGetProjectModuleCustomValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleGetProjectModuleCustomValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleValuesResultType[]>;
        }));
    }

    protected processProjectModuleGetProjectModuleCustomValues(response: HttpResponseBase): Observable<GetProjectModuleValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectModuleGetProjectModuleCustomMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ProjectModule/project-module-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleGetProjectModuleCustomMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleGetProjectModuleCustomMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleMetricsValuesResultType>;
        }));
    }

    protected processProjectModuleGetProjectModuleCustomMetricsValues(response: HttpResponseBase): Observable<GetProjectModuleMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectModuleGetProjectModuleBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectModule/project-module-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleGetProjectModuleBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleGetProjectModuleBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processProjectModuleGetProjectModuleBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectModuleGetProjectModuleLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectModule/project-module-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleGetProjectModuleLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleGetProjectModuleLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleLineChartValuesResultType[]>;
        }));
    }

    protected processProjectModuleGetProjectModuleLineChartValues(response: HttpResponseBase): Observable<GetProjectModuleLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectModuleGetProjectModuleColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectModule/project-module-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleGetProjectModuleColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleGetProjectModuleColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleColumnChartValuesResultType[]>;
        }));
    }

    protected processProjectModuleGetProjectModuleColumnChartValues(response: HttpResponseBase): Observable<GetProjectModuleColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectModuleSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectModule/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectModuleSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectModuleSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectModule/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectModuleSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectModuleGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectModule/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectModuleGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectModuleCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ProjectModule/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processProjectModuleCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectModuleGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectModule/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectModuleGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectModuleResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ProjectModule/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectModuleResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectModuleResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processProjectModuleResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectSubcontractorClient {
    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleSubcontractorValuesResultType[]>;
    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleSubcontractorMetricsValuesResultType>;
    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleSubcontractorLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleSubcontractorColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    projectSubcontractorSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectSubcontractorSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectSubcontractorGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    projectSubcontractorCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    projectSubcontractorGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectSubcontractorResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ProjectSubcontractorClient extends ReportingBaseClient implements IProjectSubcontractorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleSubcontractorValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/project-subcontractors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorGetProjectModuleSubcontractorValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorGetProjectModuleSubcontractorValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleSubcontractorValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleSubcontractorValuesResultType[]>;
        }));
    }

    protected processProjectSubcontractorGetProjectModuleSubcontractorValues(response: HttpResponseBase): Observable<GetProjectModuleSubcontractorValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleSubcontractorValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorMetricsValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleSubcontractorMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/project-subcontractors-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorGetProjectModuleSubcontractorMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorGetProjectModuleSubcontractorMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleSubcontractorMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleSubcontractorMetricsValuesResultType>;
        }));
    }

    protected processProjectSubcontractorGetProjectModuleSubcontractorMetricsValues(response: HttpResponseBase): Observable<GetProjectModuleSubcontractorMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleSubcontractorMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/project-subcontractors-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorGetProjectModuleSubcontractorBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorGetProjectModuleSubcontractorBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processProjectSubcontractorGetProjectModuleSubcontractorBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorLineChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleSubcontractorLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/project-subcontractors-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorGetProjectModuleSubcontractorLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorGetProjectModuleSubcontractorLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleSubcontractorLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleSubcontractorLineChartValuesResultType[]>;
        }));
    }

    protected processProjectSubcontractorGetProjectModuleSubcontractorLineChartValues(response: HttpResponseBase): Observable<GetProjectModuleSubcontractorLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleSubcontractorLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectSubcontractorGetProjectModuleSubcontractorColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetProjectModuleSubcontractorColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/project-subcontractors-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorGetProjectModuleSubcontractorColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorGetProjectModuleSubcontractorColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectModuleSubcontractorColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectModuleSubcontractorColumnChartValuesResultType[]>;
        }));
    }

    protected processProjectSubcontractorGetProjectModuleSubcontractorColumnChartValues(response: HttpResponseBase): Observable<GetProjectModuleSubcontractorColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProjectModuleSubcontractorColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectSubcontractorSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectSubcontractorSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectSubcontractorSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectSubcontractorSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectSubcontractorGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectSubcontractorGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectSubcontractorCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processProjectSubcontractorCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    projectSubcontractorGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processProjectSubcontractorGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    projectSubcontractorResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectSubcontractorResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectSubcontractorResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processProjectSubcontractorResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportTemplateClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    reportTemplateSearchReportTemplates(body: SearchReportTemplateParameters | undefined): Observable<ReportTemplateView[]>;
    /**
     * @return OK
     */
    reportTemplateGetByRoute(filterText: string): Observable<ReportTemplateView>;
    /**
     * @return OK
     */
    reportTemplateToggleFavorite(id: number): Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class ReportTemplateClient extends ReportingBaseClient implements IReportTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reportTemplateSearchReportTemplates(body: SearchReportTemplateParameters | undefined): Observable<ReportTemplateView[]> {
        let url_ = this.baseUrl + "/api/ReportTemplate/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTemplateSearchReportTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTemplateSearchReportTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportTemplateView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportTemplateView[]>;
        }));
    }

    protected processReportTemplateSearchReportTemplates(response: HttpResponseBase): Observable<ReportTemplateView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportTemplateView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    reportTemplateGetByRoute(filterText: string): Observable<ReportTemplateView> {
        let url_ = this.baseUrl + "/api/ReportTemplate/get-by-route/{filterText}";
        if (filterText === undefined || filterText === null)
            throw new globalThis.Error("The parameter 'filterText' must be defined.");
        url_ = url_.replace("{filterText}", encodeURIComponent("" + filterText));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTemplateGetByRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTemplateGetByRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportTemplateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportTemplateView>;
        }));
    }

    protected processReportTemplateGetByRoute(response: HttpResponseBase): Observable<ReportTemplateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportTemplateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    reportTemplateToggleFavorite(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ReportTemplate/toggle-favorite/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTemplateToggleFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTemplateToggleFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processReportTemplateToggleFavorite(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISalesLeadClient {
    /**
     * @return OK
     */
    salesLeadGetSalesLeadValues(body: GetSalesLeadValuesParameters): Observable<GetSalesLeadValuesResultType[]>;
    /**
     * @return OK
     */
    salesLeadGetSalesLeadBoxesValues(body: GetSalesLeadValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    salesLeadGetSalesLeadColumnChartValues(body: GetSalesLeadValuesParameters): Observable<GetSalesLeadColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    salesLeadGetSalesLeadMetricsValues(body: GetSalesLeadValuesParameters): Observable<GetSalesLeadMetricsValuesResultType>;
    /**
     * @return OK
     */
    salesLeadGetSalesLeadLineChartValues(body: GetSalesLeadValuesParameters): Observable<GetSalesLeadLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    salesLeadGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]>;
    /**
     * @return OK
     */
    salesLeadSaveCustomReport(body: CustomReportSalesLeadView): Observable<CustomReportSalesLeadView>;
    /**
     * @return OK
     */
    salesLeadSaveCatalogReport(body: CustomReportSalesLeadView): Observable<CustomReportSalesLeadView>;
    /**
     * @return OK
     */
    salesLeadGetCustomReport(id: number): Observable<CustomReportSalesLeadView>;
    /**
     * @return OK
     */
    salesLeadCreateSharedReport(body: CustomReportSalesLeadView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    salesLeadGetSharedReport(id: string): Observable<CustomReportSalesLeadView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    salesLeadResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class SalesLeadClient extends ReportingBaseClient implements ISalesLeadClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    salesLeadGetSalesLeadValues(body: GetSalesLeadValuesParameters): Observable<GetSalesLeadValuesResultType[]> {
        let url_ = this.baseUrl + "/api/SalesLead/sales-lead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadGetSalesLeadValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadGetSalesLeadValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesLeadValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesLeadValuesResultType[]>;
        }));
    }

    protected processSalesLeadGetSalesLeadValues(response: HttpResponseBase): Observable<GetSalesLeadValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSalesLeadValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadGetSalesLeadBoxesValues(body: GetSalesLeadValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/SalesLead/sales-lead-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadGetSalesLeadBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadGetSalesLeadBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processSalesLeadGetSalesLeadBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadGetSalesLeadColumnChartValues(body: GetSalesLeadValuesParameters): Observable<GetSalesLeadColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/SalesLead/sales-lead-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadGetSalesLeadColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadGetSalesLeadColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesLeadColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesLeadColumnChartValuesResultType[]>;
        }));
    }

    protected processSalesLeadGetSalesLeadColumnChartValues(response: HttpResponseBase): Observable<GetSalesLeadColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSalesLeadColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadGetSalesLeadMetricsValues(body: GetSalesLeadValuesParameters): Observable<GetSalesLeadMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/SalesLead/sales-lead-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadGetSalesLeadMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadGetSalesLeadMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesLeadMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesLeadMetricsValuesResultType>;
        }));
    }

    protected processSalesLeadGetSalesLeadMetricsValues(response: HttpResponseBase): Observable<GetSalesLeadMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSalesLeadMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadGetSalesLeadLineChartValues(body: GetSalesLeadValuesParameters): Observable<GetSalesLeadLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/SalesLead/sales-lead-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadGetSalesLeadLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadGetSalesLeadLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesLeadLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesLeadLineChartValuesResultType[]>;
        }));
    }

    protected processSalesLeadGetSalesLeadLineChartValues(response: HttpResponseBase): Observable<GetSalesLeadLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSalesLeadLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadGetCustomFieldColumns(organizationIds: number[]): Observable<EntityTypeCustomFieldDto[]> {
        let url_ = this.baseUrl + "/api/SalesLead/custom-field-columns?";
        if (organizationIds === undefined || organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' must be defined and cannot be null.");
        else
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadGetCustomFieldColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadGetCustomFieldColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCustomFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCustomFieldDto[]>;
        }));
    }

    protected processSalesLeadGetCustomFieldColumns(response: HttpResponseBase): Observable<EntityTypeCustomFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCustomFieldDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadSaveCustomReport(body: CustomReportSalesLeadView): Observable<CustomReportSalesLeadView> {
        let url_ = this.baseUrl + "/api/SalesLead/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportSalesLeadView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportSalesLeadView>;
        }));
    }

    protected processSalesLeadSaveCustomReport(response: HttpResponseBase): Observable<CustomReportSalesLeadView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportSalesLeadView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadSaveCatalogReport(body: CustomReportSalesLeadView): Observable<CustomReportSalesLeadView> {
        let url_ = this.baseUrl + "/api/SalesLead/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportSalesLeadView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportSalesLeadView>;
        }));
    }

    protected processSalesLeadSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportSalesLeadView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportSalesLeadView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadGetCustomReport(id: number): Observable<CustomReportSalesLeadView> {
        let url_ = this.baseUrl + "/api/SalesLead/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportSalesLeadView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportSalesLeadView>;
        }));
    }

    protected processSalesLeadGetCustomReport(response: HttpResponseBase): Observable<CustomReportSalesLeadView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportSalesLeadView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadCreateSharedReport(body: CustomReportSalesLeadView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/SalesLead/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processSalesLeadCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesLeadGetSharedReport(id: string): Observable<CustomReportSalesLeadView> {
        let url_ = this.baseUrl + "/api/SalesLead/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportSalesLeadView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportSalesLeadView>;
        }));
    }

    protected processSalesLeadGetSharedReport(response: HttpResponseBase): Observable<CustomReportSalesLeadView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportSalesLeadView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    salesLeadResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/SalesLead/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesLeadResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesLeadResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processSalesLeadResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISalesProjectsClient {
    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsSummaryValues(body: GetSalesProjectsSummaryValuesParameters): Observable<GetExternalSalesProjectsValuesResultType[]>;
    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsMetricsValues(body: GetSalesProjectsSummaryValuesParameters): Observable<GetSalesProjectsMetricsValuesResultType>;
    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsBoxesValues(body: GetSalesProjectsSummaryValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsLineChartValuesValues(body: GetSalesProjectsSummaryValuesParameters): Observable<GetSalesProjectsLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsColumnChartValuesValues(body: GetSalesProjectsSummaryValuesParameters): Observable<GetSalesProjectsExtendedColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    salesProjectsSaveCustomReport(body: CustomReportSalesProjectsSummaryView): Observable<CustomReportSalesProjectsSummaryView>;
    /**
     * @return OK
     */
    salesProjectsSaveCatalogReport(body: CustomReportSalesProjectsSummaryView): Observable<CustomReportSalesProjectsSummaryView>;
    /**
     * @return OK
     */
    salesProjectsGetCustomReport(id: number): Observable<CustomReportSalesProjectsSummaryView>;
    /**
     * @return OK
     */
    salesProjectsCreateSharedReport(body: CustomReportSalesProjectsSummaryView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    salesProjectsGetSharedReport(id: string): Observable<CustomReportSalesProjectsSummaryView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    salesProjectsResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class SalesProjectsClient extends ReportingBaseClient implements ISalesProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsSummaryValues(body: GetSalesProjectsSummaryValuesParameters): Observable<GetExternalSalesProjectsValuesResultType[]> {
        let url_ = this.baseUrl + "/api/SalesProjects/sales-projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsGetSalesProjectsSummaryValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsGetSalesProjectsSummaryValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExternalSalesProjectsValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExternalSalesProjectsValuesResultType[]>;
        }));
    }

    protected processSalesProjectsGetSalesProjectsSummaryValues(response: HttpResponseBase): Observable<GetExternalSalesProjectsValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetExternalSalesProjectsValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsMetricsValues(body: GetSalesProjectsSummaryValuesParameters): Observable<GetSalesProjectsMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/SalesProjects/sales-projects-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsGetSalesProjectsMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsGetSalesProjectsMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesProjectsMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesProjectsMetricsValuesResultType>;
        }));
    }

    protected processSalesProjectsGetSalesProjectsMetricsValues(response: HttpResponseBase): Observable<GetSalesProjectsMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSalesProjectsMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsBoxesValues(body: GetSalesProjectsSummaryValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/SalesProjects/sales-projects-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsGetSalesProjectsBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsGetSalesProjectsBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processSalesProjectsGetSalesProjectsBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsLineChartValuesValues(body: GetSalesProjectsSummaryValuesParameters): Observable<GetSalesProjectsLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/SalesProjects/sales-projects-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsGetSalesProjectsLineChartValuesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsGetSalesProjectsLineChartValuesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesProjectsLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesProjectsLineChartValuesResultType[]>;
        }));
    }

    protected processSalesProjectsGetSalesProjectsLineChartValuesValues(response: HttpResponseBase): Observable<GetSalesProjectsLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSalesProjectsLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesProjectsGetSalesProjectsColumnChartValuesValues(body: GetSalesProjectsSummaryValuesParameters): Observable<GetSalesProjectsExtendedColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/SalesProjects/sales-projects-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsGetSalesProjectsColumnChartValuesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsGetSalesProjectsColumnChartValuesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesProjectsExtendedColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesProjectsExtendedColumnChartValuesResultType[]>;
        }));
    }

    protected processSalesProjectsGetSalesProjectsColumnChartValuesValues(response: HttpResponseBase): Observable<GetSalesProjectsExtendedColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSalesProjectsExtendedColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesProjectsSaveCustomReport(body: CustomReportSalesProjectsSummaryView): Observable<CustomReportSalesProjectsSummaryView> {
        let url_ = this.baseUrl + "/api/SalesProjects/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportSalesProjectsSummaryView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportSalesProjectsSummaryView>;
        }));
    }

    protected processSalesProjectsSaveCustomReport(response: HttpResponseBase): Observable<CustomReportSalesProjectsSummaryView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportSalesProjectsSummaryView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesProjectsSaveCatalogReport(body: CustomReportSalesProjectsSummaryView): Observable<CustomReportSalesProjectsSummaryView> {
        let url_ = this.baseUrl + "/api/SalesProjects/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportSalesProjectsSummaryView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportSalesProjectsSummaryView>;
        }));
    }

    protected processSalesProjectsSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportSalesProjectsSummaryView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportSalesProjectsSummaryView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesProjectsGetCustomReport(id: number): Observable<CustomReportSalesProjectsSummaryView> {
        let url_ = this.baseUrl + "/api/SalesProjects/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportSalesProjectsSummaryView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportSalesProjectsSummaryView>;
        }));
    }

    protected processSalesProjectsGetCustomReport(response: HttpResponseBase): Observable<CustomReportSalesProjectsSummaryView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportSalesProjectsSummaryView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesProjectsCreateSharedReport(body: CustomReportSalesProjectsSummaryView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/SalesProjects/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processSalesProjectsCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    salesProjectsGetSharedReport(id: string): Observable<CustomReportSalesProjectsSummaryView> {
        let url_ = this.baseUrl + "/api/SalesProjects/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportSalesProjectsSummaryView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportSalesProjectsSummaryView>;
        }));
    }

    protected processSalesProjectsGetSharedReport(response: HttpResponseBase): Observable<CustomReportSalesProjectsSummaryView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportSalesProjectsSummaryView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    salesProjectsResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/SalesProjects/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesProjectsResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesProjectsResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processSalesProjectsResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISchedulerClient {
    /**
     * @return OK
     */
    schedulerGetSchedulerById(id: number): Observable<SchedulerView>;
    /**
     * @return OK
     */
    schedulerArchiveScheduler(body: number): Observable<void>;
    /**
     * @return OK
     */
    schedulerSave(body: SchedulerView): Observable<SchedulerView>;
    /**
     * @return OK
     */
    schedulerChangeStateScheduler(body: number): Observable<SchedulerStatuses>;
}

@Injectable({ providedIn: 'root' })
export class SchedulerClient extends ReportingBaseClient implements ISchedulerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    schedulerGetSchedulerById(id: number): Observable<SchedulerView> {
        let url_ = this.baseUrl + "/api/Scheduler/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerGetSchedulerById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerGetSchedulerById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerView>;
        }));
    }

    protected processSchedulerGetSchedulerById(response: HttpResponseBase): Observable<SchedulerView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchedulerView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerArchiveScheduler(body: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Scheduler/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerArchiveScheduler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerArchiveScheduler(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerArchiveScheduler(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerSave(body: SchedulerView): Observable<SchedulerView> {
        let url_ = this.baseUrl + "/api/Scheduler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerView>;
        }));
    }

    protected processSchedulerSave(response: HttpResponseBase): Observable<SchedulerView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchedulerView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerChangeStateScheduler(body: number): Observable<SchedulerStatuses> {
        let url_ = this.baseUrl + "/api/Scheduler/change-state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerChangeStateScheduler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerChangeStateScheduler(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerStatuses>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerStatuses>;
        }));
    }

    protected processSchedulerChangeStateScheduler(response: HttpResponseBase): Observable<SchedulerStatuses> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchedulerStatuses;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISchedulerDateRangeClient {
    /**
     * @return OK
     */
    schedulerDateRangeGetAll(): Observable<SchedulerDateRangeDto[]>;
}

@Injectable({ providedIn: 'root' })
export class SchedulerDateRangeClient extends ReportingBaseClient implements ISchedulerDateRangeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    schedulerDateRangeGetAll(): Observable<SchedulerDateRangeDto[]> {
        let url_ = this.baseUrl + "/api/SchedulerDateRange/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerDateRangeGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerDateRangeGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerDateRangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerDateRangeDto[]>;
        }));
    }

    protected processSchedulerDateRangeGetAll(response: HttpResponseBase): Observable<SchedulerDateRangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchedulerDateRangeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISchedulerExecutionClient {
    /**
     * @return OK
     */
    schedulerExecutionGetAnnuallyReports(): Observable<void>;
    /**
     * @return OK
     */
    schedulerExecutionGetQuarterReports(): Observable<void>;
    /**
     * @return OK
     */
    schedulerExecutionGetMonthlyReports(): Observable<void>;
    /**
     * @return OK
     */
    schedulerExecutionGetWeeklyReports(): Observable<void>;
    /**
     * @return OK
     */
    schedulerExecutionGetDailyReports(): Observable<void>;
    /**
     * @return OK
     */
    schedulerExecutionCreateExecutionReports(): Observable<void>;
    /**
     * @return OK
     */
    schedulerExecutionExecuteReports(): Observable<void>;
    /**
     * @return OK
     */
    schedulerExecutionExecuteReports2(id: number): Observable<void>;
    /**
     * @return OK
     */
    schedulerExecutionArchiveEndedReports(): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class SchedulerExecutionClient extends ReportingBaseClient implements ISchedulerExecutionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    schedulerExecutionGetAnnuallyReports(): Observable<void> {
        let url_ = this.baseUrl + "/api/SchedulerExecution/get-annually-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerExecutionGetAnnuallyReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerExecutionGetAnnuallyReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerExecutionGetAnnuallyReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerExecutionGetQuarterReports(): Observable<void> {
        let url_ = this.baseUrl + "/api/SchedulerExecution/get-quarter-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerExecutionGetQuarterReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerExecutionGetQuarterReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerExecutionGetQuarterReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerExecutionGetMonthlyReports(): Observable<void> {
        let url_ = this.baseUrl + "/api/SchedulerExecution/get-monthly-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerExecutionGetMonthlyReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerExecutionGetMonthlyReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerExecutionGetMonthlyReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerExecutionGetWeeklyReports(): Observable<void> {
        let url_ = this.baseUrl + "/api/SchedulerExecution/get-weekly-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerExecutionGetWeeklyReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerExecutionGetWeeklyReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerExecutionGetWeeklyReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerExecutionGetDailyReports(): Observable<void> {
        let url_ = this.baseUrl + "/api/SchedulerExecution/get-daily-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerExecutionGetDailyReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerExecutionGetDailyReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerExecutionGetDailyReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerExecutionCreateExecutionReports(): Observable<void> {
        let url_ = this.baseUrl + "/api/SchedulerExecution/create-execution-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerExecutionCreateExecutionReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerExecutionCreateExecutionReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerExecutionCreateExecutionReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerExecutionExecuteReports(): Observable<void> {
        let url_ = this.baseUrl + "/api/SchedulerExecution/execute";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerExecutionExecuteReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerExecutionExecuteReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerExecutionExecuteReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerExecutionExecuteReports2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/SchedulerExecution/force/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerExecutionExecuteReports2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerExecutionExecuteReports2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerExecutionExecuteReports2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    schedulerExecutionArchiveEndedReports(): Observable<void> {
        let url_ = this.baseUrl + "/api/SchedulerExecution/archive-finished-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerExecutionArchiveEndedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerExecutionArchiveEndedReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSchedulerExecutionArchiveEndedReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISchedulerFrequencyClient {
    /**
     * @return OK
     */
    schedulerFrequencyGetAllSchedulerFrequency(): Observable<SchedulerFrequencyDto[]>;
}

@Injectable({ providedIn: 'root' })
export class SchedulerFrequencyClient extends ReportingBaseClient implements ISchedulerFrequencyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    schedulerFrequencyGetAllSchedulerFrequency(): Observable<SchedulerFrequencyDto[]> {
        let url_ = this.baseUrl + "/api/SchedulerFrequency/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulerFrequencyGetAllSchedulerFrequency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulerFrequencyGetAllSchedulerFrequency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerFrequencyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerFrequencyDto[]>;
        }));
    }

    protected processSchedulerFrequencyGetAllSchedulerFrequency(response: HttpResponseBase): Observable<SchedulerFrequencyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchedulerFrequencyDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceCategoryClient {
    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryValues(body: GetDataFilterValuesParameters): Observable<GetServiceCategoryValuesResultType[]>;
    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceCategoryMetricsValuesResultType>;
    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceCategoryLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceCategoryColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceCategorySaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceCategorySaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceCategoryGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceCategoryCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceCategoryGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceCategoryResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceCategoryClient extends ReportingBaseClient implements IServiceCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryValues(body: GetDataFilterValuesParameters): Observable<GetServiceCategoryValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCategory/service-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategoryGetServiceCategoryValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategoryGetServiceCategoryValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceCategoryValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceCategoryValuesResultType[]>;
        }));
    }

    protected processServiceCategoryGetServiceCategoryValues(response: HttpResponseBase): Observable<GetServiceCategoryValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceCategoryValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceCategoryMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServiceCategory/service-category-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategoryGetServiceCategoryMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategoryGetServiceCategoryMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceCategoryMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceCategoryMetricsValuesResultType>;
        }));
    }

    protected processServiceCategoryGetServiceCategoryMetricsValues(response: HttpResponseBase): Observable<GetServiceCategoryMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceCategoryMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCategory/service-category-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategoryGetServiceCategoryBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategoryGetServiceCategoryBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceCategoryGetServiceCategoryBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceCategoryLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCategory/service-category-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategoryGetServiceCategoryLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategoryGetServiceCategoryLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceCategoryLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceCategoryLineChartValuesResultType[]>;
        }));
    }

    protected processServiceCategoryGetServiceCategoryLineChartValues(response: HttpResponseBase): Observable<GetServiceCategoryLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceCategoryLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCategoryGetServiceCategoryColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceCategoryColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCategory/service-category-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategoryGetServiceCategoryColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategoryGetServiceCategoryColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceCategoryColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceCategoryColumnChartValuesResultType[]>;
        }));
    }

    protected processServiceCategoryGetServiceCategoryColumnChartValues(response: HttpResponseBase): Observable<GetServiceCategoryColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceCategoryColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCategorySaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCategory/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategorySaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategorySaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCategorySaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCategorySaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCategory/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategorySaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategorySaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCategorySaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCategoryGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCategory/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategoryGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategoryGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCategoryGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCategoryCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceCategory/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategoryCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategoryCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceCategoryCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCategoryGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCategory/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategoryGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategoryGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCategoryGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceCategoryResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceCategory/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCategoryResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCategoryResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceCategoryResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceCostsClient {
    /**
     * @return OK
     */
    serviceCostsGetServiceCostValues(body: GetDataFilterValuesParameters): Observable<GetServiceCostValuesResultType[]>;
    /**
     * @return OK
     */
    serviceCostsGetServiceCostBoxes(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceCostsGetServiceCostMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceCostMetricsResultType>;
    /**
     * @return OK
     */
    serviceCostsGetServiceCostLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceCostLineChartResultType[]>;
    /**
     * @return OK
     */
    serviceCostsGetServiceCostColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceCostColumnChartResultType[]>;
    /**
     * @return OK
     */
    serviceCostsSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceCostsSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceCostsGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceCostsCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceCostsGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceCostsResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceCostsClient extends ReportingBaseClient implements IServiceCostsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceCostsGetServiceCostValues(body: GetDataFilterValuesParameters): Observable<GetServiceCostValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCosts/service-cost-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsGetServiceCostValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsGetServiceCostValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceCostValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceCostValuesResultType[]>;
        }));
    }

    protected processServiceCostsGetServiceCostValues(response: HttpResponseBase): Observable<GetServiceCostValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceCostValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCostsGetServiceCostBoxes(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCosts/service-cost-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsGetServiceCostBoxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsGetServiceCostBoxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceCostsGetServiceCostBoxes(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCostsGetServiceCostMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceCostMetricsResultType> {
        let url_ = this.baseUrl + "/api/ServiceCosts/service-cost-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsGetServiceCostMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsGetServiceCostMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceCostMetricsResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceCostMetricsResultType>;
        }));
    }

    protected processServiceCostsGetServiceCostMetricsValues(response: HttpResponseBase): Observable<GetServiceCostMetricsResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceCostMetricsResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCostsGetServiceCostLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceCostLineChartResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCosts/service-cost-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsGetServiceCostLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsGetServiceCostLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceCostLineChartResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceCostLineChartResultType[]>;
        }));
    }

    protected processServiceCostsGetServiceCostLineChartValues(response: HttpResponseBase): Observable<GetServiceCostLineChartResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceCostLineChartResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCostsGetServiceCostColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceCostColumnChartResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCosts/service-cost-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsGetServiceCostColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsGetServiceCostColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceCostColumnChartResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceCostColumnChartResultType[]>;
        }));
    }

    protected processServiceCostsGetServiceCostColumnChartValues(response: HttpResponseBase): Observable<GetServiceCostColumnChartResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceCostColumnChartResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCostsSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCosts/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCostsSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCostsSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCosts/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCostsSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCostsGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCosts/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCostsGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCostsCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceCosts/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceCostsCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCostsGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCosts/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCostsGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceCostsResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceCosts/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCostsResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCostsResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceCostsResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceCustomClient {
    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleCustomValuesResultType[]>;
    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleCustomMetricsValuesResultType>;
    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleCustomLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleCustomColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceCustomSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceCustomSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceCustomGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceCustomCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceCustomGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceCustomResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceCustomClient extends ReportingBaseClient implements IServiceCustomClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleCustomValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCustom/service-custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomGetServiceModuleCustomValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomGetServiceModuleCustomValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleCustomValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleCustomValuesResultType[]>;
        }));
    }

    protected processServiceCustomGetServiceModuleCustomValues(response: HttpResponseBase): Observable<GetServiceModuleCustomValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleCustomValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleCustomMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServiceCustom/service-custom-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomGetServiceModuleCustomMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomGetServiceModuleCustomMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleCustomMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleCustomMetricsValuesResultType>;
        }));
    }

    protected processServiceCustomGetServiceModuleCustomMetricsValues(response: HttpResponseBase): Observable<GetServiceModuleCustomMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleCustomMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCustom/service-custom-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomGetServiceModuleCustomBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomGetServiceModuleCustomBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceCustomGetServiceModuleCustomBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleCustomLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCustom/service-custom-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomGetServiceModuleCustomLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomGetServiceModuleCustomLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleCustomLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleCustomLineChartValuesResultType[]>;
        }));
    }

    protected processServiceCustomGetServiceModuleCustomLineChartValues(response: HttpResponseBase): Observable<GetServiceModuleCustomLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleCustomLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCustomGetServiceModuleCustomColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleCustomColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceCustom/service-custom-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomGetServiceModuleCustomColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomGetServiceModuleCustomColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleCustomColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleCustomColumnChartValuesResultType[]>;
        }));
    }

    protected processServiceCustomGetServiceModuleCustomColumnChartValues(response: HttpResponseBase): Observable<GetServiceModuleCustomColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleCustomColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCustomSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCustom/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCustomSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCustomSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCustom/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCustomSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCustomGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCustom/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCustomGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCustomCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceCustom/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceCustomCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceCustomGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceCustom/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceCustomGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceCustomResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceCustom/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceCustomResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceCustomResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceCustomResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceExpensesClient {
    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleExpensesValuesResultType[]>;
    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleExpensesMetricsValuesResultType>;
    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleExpensesLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleExpensesColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceExpensesSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceExpensesSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceExpensesGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceExpensesCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceExpensesGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceExpensesResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceExpensesClient extends ReportingBaseClient implements IServiceExpensesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleExpensesValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/service-expenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesGetServiceModuleExpensesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesGetServiceModuleExpensesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleExpensesValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleExpensesValuesResultType[]>;
        }));
    }

    protected processServiceExpensesGetServiceModuleExpensesValues(response: HttpResponseBase): Observable<GetServiceModuleExpensesValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleExpensesValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleExpensesMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/service-expenses-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesGetServiceModuleExpensesMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesGetServiceModuleExpensesMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleExpensesMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleExpensesMetricsValuesResultType>;
        }));
    }

    protected processServiceExpensesGetServiceModuleExpensesMetricsValues(response: HttpResponseBase): Observable<GetServiceModuleExpensesMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleExpensesMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/service-expenses-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesGetServiceModuleExpensesBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesGetServiceModuleExpensesBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceExpensesGetServiceModuleExpensesBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleExpensesLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/service-expenses-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesGetServiceModuleExpensesLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesGetServiceModuleExpensesLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleExpensesLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleExpensesLineChartValuesResultType[]>;
        }));
    }

    protected processServiceExpensesGetServiceModuleExpensesLineChartValues(response: HttpResponseBase): Observable<GetServiceModuleExpensesLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleExpensesLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceExpensesGetServiceModuleExpensesColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleExpensesColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/service-expenses-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesGetServiceModuleExpensesColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesGetServiceModuleExpensesColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleExpensesColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleExpensesColumnChartValuesResultType[]>;
        }));
    }

    protected processServiceExpensesGetServiceModuleExpensesColumnChartValues(response: HttpResponseBase): Observable<GetServiceModuleExpensesColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleExpensesColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceExpensesSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceExpensesSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceExpensesSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceExpensesSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceExpensesGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceExpensesGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceExpensesCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceExpensesCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceExpensesGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceExpensesGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceExpensesResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceExpenses/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceExpensesResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceExpensesResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceExpensesResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceLaborRoleClient {
    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborRoleValuesResultType[]>;
    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborRoleMetricsValuesResultType>;
    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborRoleLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborRoleColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceLaborRoleSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceLaborRoleSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceLaborRoleGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceLaborRoleCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceLaborRoleGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceLaborRoleResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceLaborRoleClient extends ReportingBaseClient implements IServiceLaborRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborRoleValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/service-labor-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleGetServiceModuleLaborRoleValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleGetServiceModuleLaborRoleValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleLaborRoleValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleLaborRoleValuesResultType[]>;
        }));
    }

    protected processServiceLaborRoleGetServiceModuleLaborRoleValues(response: HttpResponseBase): Observable<GetServiceModuleLaborRoleValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleLaborRoleValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/service-labor-role-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleGetServiceModuleLaborRoleBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleGetServiceModuleLaborRoleBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceLaborRoleGetServiceModuleLaborRoleBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborRoleMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/service-labor-role-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleGetServiceModuleLaborRoleMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleGetServiceModuleLaborRoleMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleLaborRoleMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleLaborRoleMetricsValuesResultType>;
        }));
    }

    protected processServiceLaborRoleGetServiceModuleLaborRoleMetricsValues(response: HttpResponseBase): Observable<GetServiceModuleLaborRoleMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleLaborRoleMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborRoleLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/service-labor-role-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleGetServiceModuleLaborRoleLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleGetServiceModuleLaborRoleLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleLaborRoleLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleLaborRoleLineChartValuesResultType[]>;
        }));
    }

    protected processServiceLaborRoleGetServiceModuleLaborRoleLineChartValues(response: HttpResponseBase): Observable<GetServiceModuleLaborRoleLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleLaborRoleLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborRoleGetServiceModuleLaborRoleColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborRoleColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/service-labor-role-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleGetServiceModuleLaborRoleColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleGetServiceModuleLaborRoleColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleLaborRoleColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleLaborRoleColumnChartValuesResultType[]>;
        }));
    }

    protected processServiceLaborRoleGetServiceModuleLaborRoleColumnChartValues(response: HttpResponseBase): Observable<GetServiceModuleLaborRoleColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleLaborRoleColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborRoleSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceLaborRoleSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborRoleSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceLaborRoleSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborRoleGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceLaborRoleGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborRoleCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceLaborRoleCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborRoleGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceLaborRoleGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceLaborRoleResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborRole/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborRoleResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborRoleResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceLaborRoleResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceLaborTaskClient {
    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborTaskValuesResultType[]>;
    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborTaskMetricsValuesResultType>;
    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborTaskLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborTaskColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceLaborTaskSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceLaborTaskSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceLaborTaskGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceLaborTaskCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceLaborTaskGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceLaborTaskResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceLaborTaskClient extends ReportingBaseClient implements IServiceLaborTaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborTaskValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/service-labor-task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskGetServiceModuleLaborTaskValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskGetServiceModuleLaborTaskValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleLaborTaskValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleLaborTaskValuesResultType[]>;
        }));
    }

    protected processServiceLaborTaskGetServiceModuleLaborTaskValues(response: HttpResponseBase): Observable<GetServiceModuleLaborTaskValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleLaborTaskValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/service-labor-task-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskGetServiceModuleLaborTaskBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskGetServiceModuleLaborTaskBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceLaborTaskGetServiceModuleLaborTaskBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborTaskMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/service-labor-task-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskGetServiceModuleLaborTaskMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskGetServiceModuleLaborTaskMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleLaborTaskMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleLaborTaskMetricsValuesResultType>;
        }));
    }

    protected processServiceLaborTaskGetServiceModuleLaborTaskMetricsValues(response: HttpResponseBase): Observable<GetServiceModuleLaborTaskMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleLaborTaskMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborTaskLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/service-labor-task-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskGetServiceModuleLaborTaskLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskGetServiceModuleLaborTaskLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleLaborTaskLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleLaborTaskLineChartValuesResultType[]>;
        }));
    }

    protected processServiceLaborTaskGetServiceModuleLaborTaskLineChartValues(response: HttpResponseBase): Observable<GetServiceModuleLaborTaskLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleLaborTaskLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborTaskGetServiceModuleLaborTaskColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleLaborTaskColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/service-labor-task-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskGetServiceModuleLaborTaskColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskGetServiceModuleLaborTaskColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleLaborTaskColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleLaborTaskColumnChartValuesResultType[]>;
        }));
    }

    protected processServiceLaborTaskGetServiceModuleLaborTaskColumnChartValues(response: HttpResponseBase): Observable<GetServiceModuleLaborTaskColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleLaborTaskColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborTaskSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceLaborTaskSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborTaskSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceLaborTaskSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborTaskGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceLaborTaskGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborTaskCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceLaborTaskCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceLaborTaskGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceLaborTaskGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceLaborTaskResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceLaborTask/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceLaborTaskResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceLaborTaskResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceLaborTaskResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceMaterialClient {
    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetServiceModuleMaterialValuesResultType[]>;
    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialBoxesValues(body: GetDataFilterValuesParametersForNonStandard): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialMetricsValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetServiceModuleMaterialMetricsValuesResultType>;
    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialLineChartValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetServiceModuleMaterialLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialColumnChartValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetServiceModuleMaterialColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceMaterialSaveCustomReport(body: CustomReportModuleMaterialView): Observable<CustomReportModuleMaterialView>;
    /**
     * @return OK
     */
    serviceMaterialSaveCatalogReport(body: CustomReportModuleMaterialView): Observable<CustomReportModuleMaterialView>;
    /**
     * @return OK
     */
    serviceMaterialGetCustomReport(id: number): Observable<CustomReportModuleMaterialView>;
    /**
     * @return OK
     */
    serviceMaterialCreateSharedReport(body: CustomReportModuleMaterialView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceMaterialGetSharedReport(id: string): Observable<CustomReportModuleMaterialView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceMaterialResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceMaterialClient extends ReportingBaseClient implements IServiceMaterialClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetServiceModuleMaterialValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/service-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGetServiceModuleMaterialValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGetServiceModuleMaterialValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleMaterialValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleMaterialValuesResultType[]>;
        }));
    }

    protected processServiceMaterialGetServiceModuleMaterialValues(response: HttpResponseBase): Observable<GetServiceModuleMaterialValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleMaterialValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialBoxesValues(body: GetDataFilterValuesParametersForNonStandard): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/service-material-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGetServiceModuleMaterialBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGetServiceModuleMaterialBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceMaterialGetServiceModuleMaterialBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialMetricsValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetServiceModuleMaterialMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/service-material-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGetServiceModuleMaterialMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGetServiceModuleMaterialMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleMaterialMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleMaterialMetricsValuesResultType>;
        }));
    }

    protected processServiceMaterialGetServiceModuleMaterialMetricsValues(response: HttpResponseBase): Observable<GetServiceModuleMaterialMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleMaterialMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialLineChartValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetServiceModuleMaterialLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/service-material-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGetServiceModuleMaterialLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGetServiceModuleMaterialLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleMaterialLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleMaterialLineChartValuesResultType[]>;
        }));
    }

    protected processServiceMaterialGetServiceModuleMaterialLineChartValues(response: HttpResponseBase): Observable<GetServiceModuleMaterialLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleMaterialLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGetServiceModuleMaterialColumnChartValues(body: GetDataFilterValuesParametersForNonStandard): Observable<GetServiceModuleMaterialColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/service-material-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGetServiceModuleMaterialColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGetServiceModuleMaterialColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleMaterialColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleMaterialColumnChartValuesResultType[]>;
        }));
    }

    protected processServiceMaterialGetServiceModuleMaterialColumnChartValues(response: HttpResponseBase): Observable<GetServiceModuleMaterialColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleMaterialColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialSaveCustomReport(body: CustomReportModuleMaterialView): Observable<CustomReportModuleMaterialView> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportModuleMaterialView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportModuleMaterialView>;
        }));
    }

    protected processServiceMaterialSaveCustomReport(response: HttpResponseBase): Observable<CustomReportModuleMaterialView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportModuleMaterialView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialSaveCatalogReport(body: CustomReportModuleMaterialView): Observable<CustomReportModuleMaterialView> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportModuleMaterialView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportModuleMaterialView>;
        }));
    }

    protected processServiceMaterialSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportModuleMaterialView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportModuleMaterialView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGetCustomReport(id: number): Observable<CustomReportModuleMaterialView> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportModuleMaterialView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportModuleMaterialView>;
        }));
    }

    protected processServiceMaterialGetCustomReport(response: HttpResponseBase): Observable<CustomReportModuleMaterialView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportModuleMaterialView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialCreateSharedReport(body: CustomReportModuleMaterialView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceMaterialCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGetSharedReport(id: string): Observable<CustomReportModuleMaterialView> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportModuleMaterialView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportModuleMaterialView>;
        }));
    }

    protected processServiceMaterialGetSharedReport(response: HttpResponseBase): Observable<CustomReportModuleMaterialView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportModuleMaterialView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceMaterialResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterial/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceMaterialResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceMaterialGroupClient {
    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleMaterialGroupValuesResultType[]>;
    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleMaterialGroupMetricsValuesResultType>;
    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleMaterialGroupLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleMaterialGroupColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceMaterialGroupSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceMaterialGroupSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceMaterialGroupGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceMaterialGroupCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceMaterialGroupGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceMaterialGroupResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceMaterialGroupClient extends ReportingBaseClient implements IServiceMaterialGroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleMaterialGroupValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/service-material-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupGetServiceModuleMaterialGroupValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupGetServiceModuleMaterialGroupValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleMaterialGroupValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleMaterialGroupValuesResultType[]>;
        }));
    }

    protected processServiceMaterialGroupGetServiceModuleMaterialGroupValues(response: HttpResponseBase): Observable<GetServiceModuleMaterialGroupValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleMaterialGroupValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/service-material-group-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupGetServiceModuleMaterialGroupBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupGetServiceModuleMaterialGroupBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceMaterialGroupGetServiceModuleMaterialGroupBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleMaterialGroupMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/service-material-group-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupGetServiceModuleMaterialGroupMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupGetServiceModuleMaterialGroupMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleMaterialGroupMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleMaterialGroupMetricsValuesResultType>;
        }));
    }

    protected processServiceMaterialGroupGetServiceModuleMaterialGroupMetricsValues(response: HttpResponseBase): Observable<GetServiceModuleMaterialGroupMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleMaterialGroupMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleMaterialGroupLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/service-material-group-line-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupGetServiceModuleMaterialGroupLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupGetServiceModuleMaterialGroupLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleMaterialGroupLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleMaterialGroupLineChartValuesResultType[]>;
        }));
    }

    protected processServiceMaterialGroupGetServiceModuleMaterialGroupLineChartValues(response: HttpResponseBase): Observable<GetServiceModuleMaterialGroupLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleMaterialGroupLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGroupGetServiceModuleMaterialGroupColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleMaterialGroupColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/service-material-group-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupGetServiceModuleMaterialGroupColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupGetServiceModuleMaterialGroupColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleMaterialGroupColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleMaterialGroupColumnChartValuesResultType[]>;
        }));
    }

    protected processServiceMaterialGroupGetServiceModuleMaterialGroupColumnChartValues(response: HttpResponseBase): Observable<GetServiceModuleMaterialGroupColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleMaterialGroupColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGroupSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceMaterialGroupSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGroupSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceMaterialGroupSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGroupGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceMaterialGroupGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGroupCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceMaterialGroupCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceMaterialGroupGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceMaterialGroupGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceMaterialGroupResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceMaterialGroup/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceMaterialGroupResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceMaterialGroupResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceMaterialGroupResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServicesModulesClient {
    /**
     * @return OK
     */
    servicesModulesGetServiceModulesValues(body: GetDataFilterValuesParameters): Observable<GetServiceModulesValuesResultType[]>;
    /**
     * @return OK
     */
    servicesModulesGetServiceModulesMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceMetricsValuesResultType>;
    /**
     * @return OK
     */
    servicesModulesGetServiceModulesColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModulesColumnChartResultType[]>;
    /**
     * @return OK
     */
    servicesModulesGetServiceModulesLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModulesLineChartResultType[]>;
    /**
     * @return OK
     */
    servicesModulesGetServiceModulesBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    servicesModulesSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    servicesModulesSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    servicesModulesGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    servicesModulesCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    servicesModulesGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    servicesModulesResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServicesModulesClient extends ReportingBaseClient implements IServicesModulesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    servicesModulesGetServiceModulesValues(body: GetDataFilterValuesParameters): Observable<GetServiceModulesValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServicesModules/service-modules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesGetServiceModulesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesGetServiceModulesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModulesValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModulesValuesResultType[]>;
        }));
    }

    protected processServicesModulesGetServiceModulesValues(response: HttpResponseBase): Observable<GetServiceModulesValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModulesValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesModulesGetServiceModulesMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServicesModules/service-modules-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesGetServiceModulesMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesGetServiceModulesMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceMetricsValuesResultType>;
        }));
    }

    protected processServicesModulesGetServiceModulesMetricsValues(response: HttpResponseBase): Observable<GetServiceMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesModulesGetServiceModulesColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModulesColumnChartResultType[]> {
        let url_ = this.baseUrl + "/api/ServicesModules/service-modules-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesGetServiceModulesColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesGetServiceModulesColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModulesColumnChartResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModulesColumnChartResultType[]>;
        }));
    }

    protected processServicesModulesGetServiceModulesColumnChartValues(response: HttpResponseBase): Observable<GetServiceModulesColumnChartResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModulesColumnChartResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesModulesGetServiceModulesLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModulesLineChartResultType[]> {
        let url_ = this.baseUrl + "/api/ServicesModules/service-modules-linechart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesGetServiceModulesLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesGetServiceModulesLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModulesLineChartResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModulesLineChartResultType[]>;
        }));
    }

    protected processServicesModulesGetServiceModulesLineChartValues(response: HttpResponseBase): Observable<GetServiceModulesLineChartResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModulesLineChartResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesModulesGetServiceModulesBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServicesModules/service-modules-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesGetServiceModulesBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesGetServiceModulesBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServicesModulesGetServiceModulesBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesModulesSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServicesModules/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServicesModulesSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesModulesSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServicesModules/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServicesModulesSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesModulesGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServicesModules/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServicesModulesGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesModulesCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServicesModules/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServicesModulesCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesModulesGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServicesModules/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServicesModulesGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    servicesModulesResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServicesModules/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesModulesResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesModulesResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServicesModulesResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServicesTermsClient {
    /**
     * @return OK
     */
    servicesTermsGetServiceTermsValues(body: GetDataFilterValuesParameters): Observable<GetServiceTermsValuesResultType[]>;
    /**
     * @return OK
     */
    servicesTermsGetServiceTermsMetrics(body: GetDataFilterValuesParameters): Observable<GetServiceTermsMetricsResultTypeGetServiceTermsTotalizedValuesDetailsAndTotalizedResultDto>;
    /**
     * @return OK
     */
    servicesTermsGetServiceTermsBoxes(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    servicesTermsGetServiceTermsColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceTermsColumnChartResultType[]>;
    /**
     * @return OK
     */
    servicesTermsGetServiceTermsLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceTermsLineChartResultType[]>;
    /**
     * @return OK
     */
    servicesTermsSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    servicesTermsSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    servicesTermsGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    servicesTermsCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    servicesTermsGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    servicesTermsResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServicesTermsClient extends ReportingBaseClient implements IServicesTermsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    servicesTermsGetServiceTermsValues(body: GetDataFilterValuesParameters): Observable<GetServiceTermsValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServicesTerms/service-terms-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsGetServiceTermsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsGetServiceTermsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceTermsValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceTermsValuesResultType[]>;
        }));
    }

    protected processServicesTermsGetServiceTermsValues(response: HttpResponseBase): Observable<GetServiceTermsValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceTermsValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesTermsGetServiceTermsMetrics(body: GetDataFilterValuesParameters): Observable<GetServiceTermsMetricsResultTypeGetServiceTermsTotalizedValuesDetailsAndTotalizedResultDto> {
        let url_ = this.baseUrl + "/api/ServicesTerms/service-terms-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsGetServiceTermsMetrics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsGetServiceTermsMetrics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceTermsMetricsResultTypeGetServiceTermsTotalizedValuesDetailsAndTotalizedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceTermsMetricsResultTypeGetServiceTermsTotalizedValuesDetailsAndTotalizedResultDto>;
        }));
    }

    protected processServicesTermsGetServiceTermsMetrics(response: HttpResponseBase): Observable<GetServiceTermsMetricsResultTypeGetServiceTermsTotalizedValuesDetailsAndTotalizedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceTermsMetricsResultTypeGetServiceTermsTotalizedValuesDetailsAndTotalizedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesTermsGetServiceTermsBoxes(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServicesTerms/service-terms-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsGetServiceTermsBoxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsGetServiceTermsBoxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServicesTermsGetServiceTermsBoxes(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesTermsGetServiceTermsColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceTermsColumnChartResultType[]> {
        let url_ = this.baseUrl + "/api/ServicesTerms/service-terms-column-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsGetServiceTermsColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsGetServiceTermsColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceTermsColumnChartResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceTermsColumnChartResultType[]>;
        }));
    }

    protected processServicesTermsGetServiceTermsColumnChartValues(response: HttpResponseBase): Observable<GetServiceTermsColumnChartResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceTermsColumnChartResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesTermsGetServiceTermsLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceTermsLineChartResultType[]> {
        let url_ = this.baseUrl + "/api/ServicesTerms/service-terms-linechart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsGetServiceTermsLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsGetServiceTermsLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceTermsLineChartResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceTermsLineChartResultType[]>;
        }));
    }

    protected processServicesTermsGetServiceTermsLineChartValues(response: HttpResponseBase): Observable<GetServiceTermsLineChartResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceTermsLineChartResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesTermsSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServicesTerms/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServicesTermsSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesTermsSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServicesTerms/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServicesTermsSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesTermsGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServicesTerms/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServicesTermsGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesTermsCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServicesTerms/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServicesTermsCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    servicesTermsGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServicesTerms/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServicesTermsGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    servicesTermsResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServicesTerms/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesTermsResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesTermsResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServicesTermsResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceSubCategoryClient {
    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryValues(body: GetDataFilterValuesParameters): Observable<GetServiceSubCategoryValuesResultType[]>;
    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceSubCategoryMetricsValuesResultType>;
    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceSubCategoryLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceSubCategoryColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceSubCategorySaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceSubCategorySaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceSubCategoryGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceSubCategoryCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceSubCategoryGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceSubCategoryResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceSubCategoryClient extends ReportingBaseClient implements IServiceSubCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryValues(body: GetDataFilterValuesParameters): Observable<GetServiceSubCategoryValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/service-sub-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategoryGetServiceSubCategoryValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategoryGetServiceSubCategoryValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceSubCategoryValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceSubCategoryValuesResultType[]>;
        }));
    }

    protected processServiceSubCategoryGetServiceSubCategoryValues(response: HttpResponseBase): Observable<GetServiceSubCategoryValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceSubCategoryValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceSubCategoryMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/service-sub-category-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategoryGetServiceSubCategoryMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategoryGetServiceSubCategoryMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceSubCategoryMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceSubCategoryMetricsValuesResultType>;
        }));
    }

    protected processServiceSubCategoryGetServiceSubCategoryMetricsValues(response: HttpResponseBase): Observable<GetServiceSubCategoryMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceSubCategoryMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/service-sub-category-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategoryGetServiceSubCategoryBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategoryGetServiceSubCategoryBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceSubCategoryGetServiceSubCategoryBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceSubCategoryLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/service-sub-category-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategoryGetServiceSubCategoryLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategoryGetServiceSubCategoryLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceSubCategoryLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceSubCategoryLineChartValuesResultType[]>;
        }));
    }

    protected processServiceSubCategoryGetServiceSubCategoryLineChartValues(response: HttpResponseBase): Observable<GetServiceSubCategoryLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceSubCategoryLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubCategoryGetServiceSubCategoryColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceSubCategoryColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/service-sub-category-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategoryGetServiceSubCategoryColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategoryGetServiceSubCategoryColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceSubCategoryColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceSubCategoryColumnChartValuesResultType[]>;
        }));
    }

    protected processServiceSubCategoryGetServiceSubCategoryColumnChartValues(response: HttpResponseBase): Observable<GetServiceSubCategoryColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceSubCategoryColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubCategorySaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategorySaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategorySaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceSubCategorySaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubCategorySaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategorySaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategorySaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceSubCategorySaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubCategoryGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategoryGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategoryGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceSubCategoryGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubCategoryCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategoryCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategoryCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceSubCategoryCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubCategoryGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategoryGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategoryGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceSubCategoryGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceSubCategoryResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceSubCategory/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubCategoryResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubCategoryResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceSubCategoryResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IServiceSubcontractorClient {
    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleSubcontractorValuesResultType[]>;
    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleSubcontractorMetricsValuesResultType>;
    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]>;
    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleSubcontractorLineChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleSubcontractorColumnChartValuesResultType[]>;
    /**
     * @return OK
     */
    serviceSubcontractorSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceSubcontractorSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceSubcontractorGetCustomReport(id: number): Observable<CustomReportServiceView>;
    /**
     * @return OK
     */
    serviceSubcontractorCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto>;
    /**
     * @return OK
     */
    serviceSubcontractorGetSharedReport(id: string): Observable<CustomReportServiceView>;
    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceSubcontractorResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class ServiceSubcontractorClient extends ReportingBaseClient implements IServiceSubcontractorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleSubcontractorValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/service-subcontractors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorGetServiceModuleSubcontractorValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorGetServiceModuleSubcontractorValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleSubcontractorValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleSubcontractorValuesResultType[]>;
        }));
    }

    protected processServiceSubcontractorGetServiceModuleSubcontractorValues(response: HttpResponseBase): Observable<GetServiceModuleSubcontractorValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleSubcontractorValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorMetricsValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleSubcontractorMetricsValuesResultType> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/service-subcontractors-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorGetServiceModuleSubcontractorMetricsValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorGetServiceModuleSubcontractorMetricsValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleSubcontractorMetricsValuesResultType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleSubcontractorMetricsValuesResultType>;
        }));
    }

    protected processServiceSubcontractorGetServiceModuleSubcontractorMetricsValues(response: HttpResponseBase): Observable<GetServiceModuleSubcontractorMetricsValuesResultType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleSubcontractorMetricsValuesResultType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorBoxesValues(body: GetDataFilterValuesParameters): Observable<BoxResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/service-subcontractors-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorGetServiceModuleSubcontractorBoxesValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorGetServiceModuleSubcontractorBoxesValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoxResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoxResultType[]>;
        }));
    }

    protected processServiceSubcontractorGetServiceModuleSubcontractorBoxesValues(response: HttpResponseBase): Observable<BoxResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoxResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorLineChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleSubcontractorLineChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/service-subcontractors-linear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorGetServiceModuleSubcontractorLineChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorGetServiceModuleSubcontractorLineChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleSubcontractorLineChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleSubcontractorLineChartValuesResultType[]>;
        }));
    }

    protected processServiceSubcontractorGetServiceModuleSubcontractorLineChartValues(response: HttpResponseBase): Observable<GetServiceModuleSubcontractorLineChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleSubcontractorLineChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubcontractorGetServiceModuleSubcontractorColumnChartValues(body: GetDataFilterValuesParameters): Observable<GetServiceModuleSubcontractorColumnChartValuesResultType[]> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/service-subcontractors-column";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorGetServiceModuleSubcontractorColumnChartValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorGetServiceModuleSubcontractorColumnChartValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceModuleSubcontractorColumnChartValuesResultType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceModuleSubcontractorColumnChartValuesResultType[]>;
        }));
    }

    protected processServiceSubcontractorGetServiceModuleSubcontractorColumnChartValues(response: HttpResponseBase): Observable<GetServiceModuleSubcontractorColumnChartValuesResultType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetServiceModuleSubcontractorColumnChartValuesResultType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubcontractorSaveCustomReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/custom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorSaveCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorSaveCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceSubcontractorSaveCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubcontractorSaveCatalogReport(body: CustomReportServiceView): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorSaveCatalogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorSaveCatalogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceSubcontractorSaveCatalogReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubcontractorGetCustomReport(id: number): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/custom/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorGetCustomReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorGetCustomReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceSubcontractorGetCustomReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubcontractorCreateSharedReport(body: CustomReportServiceView): Observable<SharedReportDto> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorCreateSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorCreateSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedReportDto>;
        }));
    }

    protected processServiceSubcontractorCreateSharedReport(response: HttpResponseBase): Observable<SharedReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SharedReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    serviceSubcontractorGetSharedReport(id: string): Observable<CustomReportServiceView> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/shared/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorGetSharedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorGetSharedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportServiceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportServiceView>;
        }));
    }

    protected processServiceSubcontractorGetSharedReport(response: HttpResponseBase): Observable<CustomReportServiceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomReportServiceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIds (optional) 
     * @return OK
     */
    serviceSubcontractorResultAvailableColumns(organizationIds: number[] | undefined): Observable<ReportResultColumnDto[]> {
        let url_ = this.baseUrl + "/api/ServiceSubcontractor/available-columns?";
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceSubcontractorResultAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceSubcontractorResultAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportResultColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportResultColumnDto[]>;
        }));
    }

    protected processServiceSubcontractorResultAvailableColumns(response: HttpResponseBase): Observable<ReportResultColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportResultColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    /**
     * @return OK
     */
    userIsLoggedIn(): Observable<boolean>;
    /**
     * @return OK
     */
    userGetAuthenticatedUser(): Observable<UserDto>;
    /**
     * @return OK
     */
    userGetById(id: number): Observable<UserDto>;
    /**
     * @return OK
     */
    userSearchUsers(body: SearchUsersParameters): Observable<SearchUserDto[]>;
}

@Injectable({ providedIn: 'root' })
export class UserClient extends ReportingBaseClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    userIsLoggedIn(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/is-logged-in";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserIsLoggedIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserIsLoggedIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUserIsLoggedIn(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userGetAuthenticatedUser(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/User/authenticated-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserGetAuthenticatedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserGetAuthenticatedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUserGetAuthenticatedUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userGetById(id: number): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUserGetById(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userSearchUsers(body: SearchUsersParameters): Observable<SearchUserDto[]> {
        let url_ = this.baseUrl + "/api/User/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSearchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSearchUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchUserDto[]>;
        }));
    }

    protected processUserSearchUsers(response: HttpResponseBase): Observable<SearchUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchUserDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface BaseEstimateStatusDto {
    id: number;
    name: string | undefined;
}

export interface BoxResultType {
    title: string | undefined;
    value: number;
    formatType: number;
}

export interface ChangeOrderStatusDto {
    id: number;
    name: string | undefined;
}

export interface CustomFieldColumnValueDto {
    entityTypeCustomFieldId: number;
    columnName: string | undefined;
    columnOrder: number;
    columnTypeId: number;
    value: string | undefined;
    readonly rawValue: any | undefined;
}

export interface CustomReportAccountView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetAccountValuesParameters;
}

export interface CustomReportAwardedEstimateView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetEstimateAwardedValuesParameters;
}

export interface CustomReportAwardedFinalEstimateView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetAwardedFinalEstimatesValuesParameters;
}

export interface CustomReportBuildingView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetBuildingValuesParameters;
}

export interface CustomReportChangeOrderView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetChangeOrdersValuesParameters;
}

export interface CustomReportCompanyView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetCompanyValuesParameters;
}

export interface CustomReportCompetingBiddersView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetCompetingBiddersValuesParameters;
}

export interface CustomReportEstimateView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetEstimateValuesParameters;
}

export interface CustomReportModuleMaterialView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetDataFilterValuesParametersForNonStandard;
}

export interface CustomReportOpportunityView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetOpportunityValuesParameters;
}

export interface CustomReportPreferenceView {
    id: number;
    customReportId: number;
    customReportName: string | undefined;
    columnId: string | undefined;
    width: number | undefined;
    sortDirection: string | undefined;
}

export interface CustomReportSalesLeadView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetSalesLeadValuesParameters;
}

export interface CustomReportSalesProjectsSummaryView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetSalesProjectsSummaryValuesParameters;
}

export interface CustomReportServiceView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
    filterParameters: GetDataFilterValuesParameters;
}

export interface CustomReportUserFavoriteView {
    id: number;
    userId: number;
    customReportId: number;
    reportTemplateId: number | undefined;
    customReportName: string | undefined;
    reportName: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    reportTemplateUrl: string | undefined;
}

export interface CustomReportView {
    id: number;
    name: string | undefined;
    reportTemplateId: number;
    reportTemplateName: string | undefined;
    reportTemplateUrl: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateGroupName: string | undefined;
    isActive: boolean;
    hiddenColumns: string[] | undefined;
    groupingColumns: string[] | undefined;
    orderColumns: string[] | undefined;
    isPublic: boolean;
    organizations: number[] | undefined;
    isFavorite: boolean | undefined;
    schedulerId: number | undefined;
    schedulerStatusId: number | undefined;
    schedulerStatusName: string | undefined;
    schedulerFrequencyId: number | undefined;
    lastRun: Date | undefined;
    customReportPreferences: CustomReportPreferenceView[] | undefined;
    canEditCatalogReport: boolean;
    canDeleteCatalogReport: boolean;
    canAddToCatalog: boolean;
    hasFullAccessToReport: boolean;
}

export interface DivisionView {
    id: number;
    name: string | undefined;
    organizationName: string | undefined;
    order: number;
    isActive: boolean;
    isReserved: boolean | undefined;
}

export interface EntityTypeCustomFieldDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    customFieldTypeId: number;
    order: number;
    isActive: boolean;
}

export interface GetAccountColumnChartValuesResultType {
    salesPerson: string | undefined;
    awardedAmount: number;
}

export interface GetAccountLineChartValuesResultType {
    accountName: string | undefined;
    awardedAmount: number;
    awardedCount: number;
    opportunityQty: number;
}

export interface GetAccountMetricsValuesResultType {
    avgAwardedAmount: number;
    minAwardedAmount: number;
    medAwardedAmount: number;
    maxAwardedAmount: number;
}

export interface GetAccountValuesParameters {
    userId: number | undefined;
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    relatedOpportunitiesSalesPersonIds: number[] | undefined;
    opportunityIds: number[] | undefined;
    opportunityDueDateFrom: Date | undefined;
    opportunityDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    divisionIds: number[] | undefined;
    customerIds: number[] | undefined;
    accountIds: number[] | undefined;
    includeOpportunityArchived: boolean | undefined;
    includeArchived: boolean | undefined;
}

export interface GetAccountValuesResultType {
    accountName: string | undefined;
    accountType: string | undefined;
    accountMarket: string | undefined;
    opportunityQty: number;
    salesPersons: string | undefined;
    awardedCount: number;
    awardedAmount: number;
    organization: string | undefined;
    condition: string | undefined;
    accountLastUpdatedNote: string | undefined;
    modificationDate: Date | undefined;
    entityId: number;
    customFieldColumnValues: CustomFieldColumnValueDto[] | undefined;
}

export interface GetAwardedFinalEstimatesMetricsValuesResultType {
    averageGrossMarginPercent: number;
    minGrossMarginPercent: number;
    maxGrossMarginPercent: number;
    medianGrossMarginPercent: number;
    averageSellPrice: number;
    minSellPrice: number;
    maxSellPrice: number;
    medianSellPrice: number;
    averageTDC: number;
    minTDC: number;
    maxTDC: number;
    medianTDC: number;
}

export interface GetAwardedFinalEstimatesValuesParameters {
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    projectIds: number[] | undefined;
    projectDueDateFrom: Date | undefined;
    projectDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    projectStatusIds: number[] | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    userId: number | undefined;
}

export interface GetBuildingColumnChartValuesResultType {
    salesPerson: string | undefined;
    avgAwardedCountPerBuilding: number;
    avgAwardedAmountPerSqFt: number;
}

export interface GetBuildingLineChartValuesResultType {
    buildingName: string | undefined;
    awardedAmount: number;
    avgAwardedAmountPerSqFt: number;
}

export interface GetBuildingMetricsValuesResultType {
    avgBuildingSqFt: number;
    minBuildingSqFt: number;
    medBuildingSqFt: number;
    maxBuildingSqFt: number;
    avgAwardedAmountPerSqFt: number;
    minAwardedAmountPerSqFt: number;
    medAwardedAmountPerSqFt: number;
    maxAwardedAmountPerSqFt: number;
}

export interface GetBuildingValuesParameters {
    userId: number | undefined;
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    relatedOpportunitiesSalesPersonIds: number[] | undefined;
    opportunityIds: number[] | undefined;
    opportunityDueDateFrom: Date | undefined;
    opportunityDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    divisionIds: number[] | undefined;
    customerIds: number[] | undefined;
    accountIds: number[] | undefined;
    companyPropertyManagerIds: number[] | undefined;
    stateId: number | undefined;
    buildingClassId: number | undefined;
    includeOpportunityArchived: boolean | undefined;
    includeArchived: boolean | undefined;
}

export interface GetBuildingValuesResultType {
    entityId: number;
    buildingName: string | undefined;
    alternateName: string | undefined;
    buildingContact: string | undefined;
    address: string | undefined;
    buildingClass: string | undefined;
    numberOfFloors: number;
    size: number;
    opportunityQty: number;
    salesPersons: string | undefined;
    awardedCount: number;
    awardedAmount: number;
    awardedAmountPerSqFt: number;
    organization: string | undefined;
    condition: string | undefined;
    buildingLastUpdatedNote: string | undefined;
    modificationDate: Date | undefined;
    customFieldColumnValues: CustomFieldColumnValueDto[] | undefined;
}

export interface GetChangeOrdersColumnChartValuesResultType {
    salesPerson: string | undefined;
    sellPrice: number;
}

export interface GetChangeOrdersLineChartValuesResultType {
    changeOrderName: string | undefined;
    sellPrice: number;
    grossMargin: number;
}

export interface GetChangeOrdersMetricsFormattedValuesResultType {
    submittedOnHoldQty: number;
    submittedOnHoldGrossMargin: number;
    submittedOnHoldSellPrice: number;
    rejectedCancelQty: number;
    rejectedCancelGrossMargin: number;
    rejectedCancelSellPrice: number;
    acceptedQty: number;
    acceptedGrossMargin: number;
    acceptedSellPrice: number;
}

export interface GetChangeOrdersValuesParameters {
    organizationIds: number[] | undefined;
    projectIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    projectDueDateFrom: Date | undefined;
    projectDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    projectStatusIds: number[] | undefined;
    changeOrderStatusIds: number[] | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    includeArchived: boolean | undefined;
    userId: number | undefined;
    sellPriceFrom: number | undefined;
    sellPriceTo: number | undefined;
}

export interface GetCompanyColumnChartValuesResultType {
    salesPerson: string | undefined;
    awardedAmount: number;
}

export interface GetCompanyLineChartValuesResultType {
    companyName: string | undefined;
    awardedAmount: number;
    awardedCount: number;
    opportunityQty: number;
}

export interface GetCompanyMetricsValuesResultType {
    avgAwardedAmount: number;
    minAwardedAmount: number;
    medAwardedAmount: number;
    maxAwardedAmount: number;
}

export interface GetCompanyValuesParameters {
    userId: number | undefined;
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    relatedOpportunitiesSalesPersonIds: number[] | undefined;
    opportunityIds: number[] | undefined;
    opportunityDueDateFrom: Date | undefined;
    opportunityDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    divisionIds: number[] | undefined;
    customerIds: number[] | undefined;
    accountIds: number[] | undefined;
    companyTypeId: number | undefined;
    includeOpportunityArchived: boolean | undefined;
    includeArchived: boolean | undefined;
}

export interface GetCompanyValuesResultType {
    entityId: number;
    companyName: string | undefined;
    account: string | undefined;
    mainOfficeFullAddress: string | undefined;
    mainContact: string | undefined;
    companyType: string | undefined;
    market: string | undefined;
    opportunityQty: number;
    salesPersons: string | undefined;
    awardedCount: number;
    awardedAmount: number;
    organization: string | undefined;
    condition: string | undefined;
    companyLastUpdatedNote: string | undefined;
    modificationDate: Date | undefined;
    customFieldColumnValues: CustomFieldColumnValueDto[] | undefined;
}

export interface GetCompetingBiddersColumnChartValuesResultType {
    salesPersonName: string | undefined;
    acceptedTotalSellPrice: number;
    rejectedTotalSellPrice: number;
}

export interface GetCompetingBiddersLineChartValuesResultType {
    bidder: string | undefined;
    acceptedSellPrice: number;
    rejectedSellPrice: number;
}

export interface GetCompetingBiddersMetricsValuesResultType {
    acceptedProjectQty: number;
    acceptedPercentage: number;
    rejectedProjectQty: number;
    rejectedPercentage: number;
}

export interface GetCompetingBiddersValuesParameters {
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    projectIds: number[] | undefined;
    projectDueDateFrom: Date | undefined;
    projectDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    projectStatusIds: number[] | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    competingBidderIds: number[] | undefined;
    userId: number | undefined;
}

export interface GetCompetingBiddersValuesResultType {
    bidder: string | undefined;
    acceptedSellPrice: number;
    acceptedGrossMarginPercentage: number;
    acceptedProjectQty: number;
    acceptedPercentage: number;
    rejectedSellPrice: number;
    rejectedGrossMarginPercentage: number;
    rejectedProjectQty: number;
    rejectedPercentage: number;
}

export interface GetDataFilterValuesParameters {
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    projectIds: number[] | undefined;
    projectDueDateFrom: Date | undefined;
    projectDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    projectStatusIds: number[] | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    userId: number | undefined;
}

export interface GetDataFilterValuesParametersForNonStandard {
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    projectIds: number[] | undefined;
    projectDueDateFrom: Date | undefined;
    projectDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    projectStatusIds: number[] | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    userId: number | undefined;
    nonStandard: boolean | undefined;
}

export interface GetEstimateAwardedColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalAwardedAmount: number;
    totalGrossMarginPercentage: number;
}

export interface GetEstimateAwardedLineChartValuesResultType {
    estimateName: string | undefined;
    totalAwardedAmount: number;
    totalGrossMarginPercentage: number;
}

export interface GetEstimateAwardedMetricsValuesResultType {
    avgAwardedAmount: number;
    minAwardedAmount: number;
    medAwardedAmount: number;
    maxAwardedAmount: number;
    avgGrossMarginPercentage: number;
    minGrossMarginPercentage: number;
    medGrossMarginPercentage: number;
    maxGrossMarginPercentage: number;
}

export interface GetEstimateAwardedValuesParameters {
    userId: number | undefined;
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    opportunityIds: number[] | undefined;
    awardedDateFrom: Date | undefined;
    awardedDateTo: Date | undefined;
    awardedAmountFrom: number | undefined;
    awardedAmountTo: number | undefined;
    estimateTypeId: number | undefined;
    opportunityStatusIds: number[] | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    divisionIds: number[] | undefined;
    customerIds: number[] | undefined;
    accountIds: number[] | undefined;
    probabilityValueFrom: number | undefined;
    probabilityValueTo: number | undefined;
    includeArchived: boolean | undefined;
}

export interface GetEstimateAwardedValuesResultType {
    baseEstimateId: number | undefined;
    estimateName: string | undefined;
    estimateType: string | undefined;
    awardedDate: Date;
    oid: number | undefined;
    opportunityName: string | undefined;
    customer: string | undefined;
    account: string | undefined;
    awardedAmount: number;
    grossMarginPercentage: number;
    division: string | undefined;
    salesPerson: string | undefined;
    status: string | undefined;
    market: string | undefined;
    leadSource: string | undefined;
    organization: string | undefined;
    probability: string | undefined;
    condition: string | undefined;
    opportunityLastUpdatedNote: string | undefined;
    projectArchived: boolean;
    dueDate: Date | undefined;
    creationDate: Date | undefined;
    expectedBookingDate: Date | undefined;
    companyNames: string | undefined;
    companyRoleNames: string | undefined;
    actualValue: number;
    avgTotalTerm: number;
    totalTerm: number;
    actualGRossMarginPercentage: number;
    projectID: string | undefined;
    buildingName: string | undefined;
    potentialValue: number;
    proposedGrossMarginPercent: number;
    potentialTermAverage: number;
    potentialNumberOfTerms: number;
    speculativeValue: number;
    totalBuildingSqFt: number;
    sellPriceSqFt: number;
    productTypes: string | undefined;
    projectDuration: number | undefined;
    competingBidder: string | undefined;
    bidCategories: string | undefined;
    modificationDate: Date | undefined;
    customFieldColumnValues: CustomFieldColumnValueDto[] | undefined;
}

export interface GetEstimateColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalBidAmount: number;
    totalGrossMarginPercentage: number;
}

export interface GetEstimateLineChartValuesResultType {
    estimateName: string | undefined;
    totalBidAmount: number;
    totalGrossMarginPercentage: number;
}

export interface GetEstimateMetricsValuesResultType {
    avgBidAmount: number;
    minBidAmount: number;
    medBidAmount: number;
    maxBidAmount: number;
    avgGrossMarginPercentage: number;
    minGrossMarginPercentage: number;
    medGrossMarginPercentage: number;
    maxGrossMarginPercentage: number;
}

export interface GetEstimateValuesParameters {
    userId: number | undefined;
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    opportunityIds: number[] | undefined;
    bidDateFrom: Date | undefined;
    bidDateTo: Date | undefined;
    bidAmountFrom: number | undefined;
    bidAmountTo: number | undefined;
    estimateTypeId: number | undefined;
    opportunityStatusIds: number[] | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    divisionIds: number[] | undefined;
    customerIds: number[] | undefined;
    accountIds: number[] | undefined;
    probabilityValueFrom: number | undefined;
    probabilityValueTo: number | undefined;
    includeArchived: boolean | undefined;
}

export interface GetEstimateValuesResultType {
    baseEstimateId: number | undefined;
    estimateName: string | undefined;
    estimateType: string | undefined;
    bidDate: Date;
    oid: number | undefined;
    opportunityName: string | undefined;
    customer: string | undefined;
    account: string | undefined;
    bidAmount: number;
    grossMarginPercentage: number;
    division: string | undefined;
    salesPerson: string | undefined;
    status: string | undefined;
    market: string | undefined;
    leadSource: string | undefined;
    organization: string | undefined;
    probability: string | undefined;
    condition: string | undefined;
    opportunityLastUpdatedNote: string | undefined;
    projectArchived: boolean;
}

export interface GetExternalAwardedFinalEstimatesValuesResultType {
    projectId: number | undefined;
    projectName: string | undefined;
    projectDueDate: Date | undefined;
    projectStatus: string | undefined;
    organization: string | undefined;
    salesPerson: string | undefined;
    alternateQty: number;
    finalEstimateId: string | undefined;
    finalEstimateName: string | undefined;
    grossMargin: number;
    sellPrice: number;
    tdc: number;
    markets: string[] | undefined;
    lead: string | undefined;
    division: string | undefined;
    customer: string | undefined;
    account: string | undefined;
    probability: string | undefined;
    opportunityLastUpdatedNote: string | undefined;
    projectArchived: boolean;
}

export interface GetExternalChangeOrderValuesResultType {
    projectId: number | undefined;
    projectName: string | undefined;
    projectDueDate: Date | undefined;
    projectStatus: string | undefined;
    organization: string | undefined;
    salesPerson: string | undefined;
    changeOrderId: number | undefined;
    changeOrderName: string | undefined;
    changeOrderStatus: string | undefined;
    grossMargin: number;
    sellPrice: number;
    markets: string[] | undefined;
    lead: string | undefined;
    division: string | undefined;
    customer: string | undefined;
    account: string | undefined;
    opportunityLastUpdatedNote: string | undefined;
    oid: number | undefined;
    changeOrderDescription: string | undefined;
    changeOrderClientCONumber: string | undefined;
    changeOrderReference: number | undefined;
    tdc: number;
    bidBaseContract: number;
    bidNewContract: number;
    grossMarginPercent: number;
    totalGrossMarginPercentage: number;
    projectNumber: string | undefined;
    expectedBookingDate: Date | undefined;
    projectStartDate: Date | undefined;
    projectEndDate: Date | undefined;
    projectDuration: number | undefined;
    projectArchived: boolean;
}

export interface GetExternalSalesProjectsValuesResultType {
    projectId: number | undefined;
    projectName: string | undefined;
    projectDueDate: Date | undefined;
    status: string | undefined;
    organization: string | undefined;
    salesPerson: string | undefined;
    sellPrice: number;
    grossMargin: number;
    totalBuildingSqFt: number;
    pricePerSqFt: number;
    markets: string[] | undefined;
    lead: string | undefined;
    competingBidders: string[] | undefined;
    division: string | undefined;
    customer: string | undefined;
    account: string | undefined;
    potentialValue: number | undefined;
    probability: string | undefined;
    speculativeValue: number | undefined;
    opportunityLastUpdatedNote: string | undefined;
    customFieldValues: string | undefined;
    projectArchived: boolean;
}

export interface GetFinalEstimatesColumnChartValuesResultType {
    salesPerson: string | undefined;
    sellPrice: number;
    tdc: number;
}

export interface GetFinalEstimatesLineChartValuesResultType {
    projectName: string | undefined;
    grossMargin: number;
    sellPrice: number;
}

export interface GetOpportunityColumnChartValuesResultType {
    salesPerson: string | undefined;
    opportunityValue: number;
    bidAmount: number;
    awardedAmount: number;
    acceptedProjectsPercentage: number;
    acceptedValuePercentage: number;
}

export interface GetOpportunityLineChartValuesResultType {
    opportunityName: string | undefined;
    potentialValue: number;
    proposedGrossMarginPercentage: number;
    actualValue: number;
    actualGrossMarginPercentage: number;
}

export interface GetOpportunityMetricsValuesResultType {
    avgPotentialValue: number;
    minPotentialValue: number;
    medPotentialValue: number;
    maxPotentialValue: number;
    avgProposedGrossMarginPercentage: number;
    minProposedGrossMarginPercentage: number;
    medProposedGrossMarginPercentage: number;
    maxProposedGrossMarginPercentage: number;
    avgActualValue: number;
    minActualValue: number;
    medActualValue: number;
    maxActualValue: number;
    avgActualGrossMarginPercentage: number;
    minActualGrossMarginPercentage: number;
    medActualGrossMarginPercentage: number;
    maxActualGrossMarginPercentage: number;
}

export interface GetOpportunityValuesParameters {
    userId: number | undefined;
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    opportunityIds: number[] | undefined;
    opportunityDueDateFrom: Date | undefined;
    opportunityDueDateTo: Date | undefined;
    opportunityDueDateIncludeNull: boolean | undefined;
    opportunityCreationDateFrom: Date | undefined;
    opportunityCreationDateTo: Date | undefined;
    opportunityCreationDateIncludeNull: boolean | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectStartDateIncludeNull: boolean | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    projectEndDateIncludeNull: boolean | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    divisionIds: number[] | undefined;
    customerIds: number[] | undefined;
    accountIds: number[] | undefined;
    competingBidderIds: number[] | undefined;
    potentialValueFrom: number | undefined;
    potentialValueTo: number | undefined;
    probabilityValueFrom: number | undefined;
    probabilityValueTo: number | undefined;
    expectedResponseDateFrom: Date | undefined;
    expectedResponseDateTo: Date | undefined;
    expectedResponseDateIncludeNull: boolean | undefined;
    includeArchived: boolean | undefined;
    opportunityStatusIds: number[] | undefined;
    bidCategoryIds: number[] | undefined;
    companyIds: number[] | undefined;
    companyRoleIds: number[] | undefined;
    productTypesIds: number[] | undefined;
    filterText: string | undefined;
}

export interface GetOpportunityValuesResultType {
    entityId: number;
    opportunityName: string | undefined;
    dueDate: Date | undefined;
    creationDate: Date | undefined;
    expectedBookingDate: Date | undefined;
    customer: string | undefined;
    companyNames: string | undefined;
    companyRoleNames: string | undefined;
    account: string | undefined;
    actualValue: number;
    avgTotalTerm: number;
    totalTerm: number;
    actualGRossMarginPercentage: number;
    bid: string | undefined;
    projectID: string | undefined;
    division: string | undefined;
    salesPerson: string | undefined;
    status: string | undefined;
    probability: string | undefined;
    buildingName: string | undefined;
    potentialValue: number;
    proposedGrossMarginPercent: number;
    potentialTermAverage: number;
    potentialNumberOfTerms: number;
    speculativeValue: number;
    totalBuildingSqFt: number;
    sellPriceSqFt: number;
    market: string | undefined;
    productTypes: string | undefined;
    leadSource: string | undefined;
    projectDuration: number | undefined;
    organization: string | undefined;
    competingBidder: string | undefined;
    bidCategories: string | undefined;
    condition: string | undefined;
    opportunityLastUpdatedNote: string | undefined;
    modificationDate: Date | undefined;
    projectArchived: boolean;
    customFieldColumnValues: CustomFieldColumnValueDto[] | undefined;
}

export interface GetPointsListSystemClusterChartValuesResultType {
    salesPersonName: string | undefined;
    totalMaterialCost: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetPointsListSystemLineChartValuesResultType {
    systemName: string | undefined;
    totalMaterialCost: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetPointsListSystemMetricsValuesResultType {
    avgTypicalOf: number;
    minTypicalOf: number;
    medTypicalOf: number;
    maxTypicalOf: number;
    avgPoints: number;
    minPoints: number;
    medPoints: number;
    maxPoints: number;
    avgParts: number;
    minParts: number;
    medParts: number;
    maxParts: number;
    avgMaterialCost: number;
    minMaterialCost: number;
    medMaterialCost: number;
    maxMaterialCost: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
    avgTotalCost: number;
    minTotalCost: number;
    medTotalCost: number;
    maxTotalCost: number;
}

export interface GetPointsListSystemValuesResultType {
    name: string | undefined;
    usedTotal: number;
    avgPerEstimate: number;
    avgTypicalOf: number;
    minTypicalOf: number;
    medTypicalOf: number;
    maxTypicalOf: number;
    avgPoints: number;
    minPoints: number;
    medPoints: number;
    maxPoints: number;
    avgParts: number;
    minParts: number;
    medParts: number;
    maxParts: number;
    avgMaterialCost: number;
    minMaterialCost: number;
    medMaterialCost: number;
    maxMaterialCost: number;
    grandTotalMaterialCost: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
    grandTotalLaborCost: number;
    avgTotalCost: number;
    minTotalCost: number;
    medTotalCost: number;
    maxTotalCost: number;
    grandTotalCost: number;
}

export interface GetProjectModuleColumnChartValuesResultType {
    salesPersonName: string | undefined;
    subcontractorGrossMarginPercent: number;
    subcontractorSellPrice: number;
    subcontractorPercent: number;
    expensesGrossMarginPercent: number;
    expensesGrossSellPrice: number;
    expensesPercent: number;
    customGrossMarginPercent: number;
    customSellPrice: number;
    customPercent: number;
    laborGrossMarginPercent: number;
    laborSellPrice: number;
    laborPercent: number;
    materialGrossMarginPercent: number;
    materialSellPrice: number;
    materialPercent: number;
}

export interface GetProjectModuleCustomColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalSellPrice: number;
    totalCustomCost: number;
}

export interface GetProjectModuleCustomLineChartValuesResultType {
    description: string | undefined;
    totalSellPrice: number;
    totalCustomCost: number;
    avgDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
}

export interface GetProjectModuleCustomMetricsValuesResultType {
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgCustomCost: number;
    minCustomCost: number;
    medCustomCost: number;
    maxCustomCost: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetProjectModuleCustomValuesResultType {
    description: string | undefined;
    totalSellPrice: number;
    totalCustomCost: number;
    avgCustomCost: number;
    minCustomCost: number;
    medCustomCost: number;
    maxCustomCost: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetProjectModuleExpensesColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalSellPrice: number;
    totalExpenseCost: number;
}

export interface GetProjectModuleExpensesLineChartValuesResultType {
    expenseType: string | undefined;
    totalSellPrice: number;
    totalExpenseCost: number;
    avgDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
}

export interface GetProjectModuleExpensesMetricsValuesResultType {
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgExpenseCost: number;
    minExpenseCost: number;
    medExpenseCost: number;
    maxExpenseCost: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetProjectModuleExpensesValuesResultType {
    expenseType: string | undefined;
    totalSellPrice: number;
    totalExpenseCost: number;
    avgExpenseCost: number;
    minExpenseCost: number;
    medExpenseCost: number;
    maxExpenseCost: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetProjectModuleLaborRoleColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalHours: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetProjectModuleLaborRoleLineChartValuesResultType {
    laborRole: string | undefined;
    totalHours: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetProjectModuleLaborRoleMetricsValuesResultType {
    avgRegularHours: number;
    minRegularHours: number;
    medRegularHours: number;
    maxRegularHours: number;
    avgHoursOvertimeOne: number;
    minHoursOvertimeOne: number;
    medHoursOvertimeOne: number;
    maxHoursOvertimeOne: number;
    avgHoursOvertimeTwo: number;
    minHoursOvertimeTwo: number;
    medHoursOvertimeTwo: number;
    maxHoursOvertimeTwo: number;
    avgTotalHours: number;
    minTotalHours: number;
    medTotalHours: number;
    maxTotalHours: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
}

export interface GetProjectModuleLaborRoleValuesResultType {
    laborRole: string | undefined;
    avgRegularHours: number;
    minRegularHours: number;
    medRegularHours: number;
    maxRegularHours: number;
    avgHoursOvertimeOne: number;
    minHoursOvertimeOne: number;
    medHoursOvertimeOne: number;
    maxHoursOvertimeOne: number;
    avgHoursOvertimeTwo: number;
    minHoursOvertimeTwo: number;
    medHoursOvertimeTwo: number;
    maxHoursOvertimeTwo: number;
    avgTotalHours: number;
    minTotalHours: number;
    medTotalHours: number;
    maxTotalHours: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
}

export interface GetProjectModuleLaborTaskColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalHours: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetProjectModuleLaborTaskLineChartValuesResultType {
    laborTask: string | undefined;
    totalHours: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetProjectModuleLaborTaskMetricsValuesResultType {
    avgRegularHours: number;
    minRegularHours: number;
    medRegularHours: number;
    maxRegularHours: number;
    avgHoursOvertimeOne: number;
    minHoursOvertimeOne: number;
    medHoursOvertimeOne: number;
    maxHoursOvertimeOne: number;
    avgHoursOvertimeTwo: number;
    minHoursOvertimeTwo: number;
    medHoursOvertimeTwo: number;
    maxHoursOvertimeTwo: number;
    avgTotalHours: number;
    minTotalHours: number;
    medTotalHours: number;
    maxTotalHours: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
}

export interface GetProjectModuleLaborTaskValuesResultType {
    laborCode: string | undefined;
    laborTask: string | undefined;
    avgRegularHours: number;
    minRegularHours: number;
    medRegularHours: number;
    maxRegularHours: number;
    avgHoursOvertimeOne: number;
    minHoursOvertimeOne: number;
    medHoursOvertimeOne: number;
    maxHoursOvertimeOne: number;
    avgHoursOvertimeTwo: number;
    minHoursOvertimeTwo: number;
    medHoursOvertimeTwo: number;
    maxHoursOvertimeTwo: number;
    avgTotalHours: number;
    minTotalHours: number;
    medTotalHours: number;
    maxTotalHours: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
}

export interface GetProjectModuleLineChartValuesResultType {
    projectName: string | undefined;
    estimateGrossMargin: number;
    estimateSellPrice: number;
}

export interface GetProjectModuleMaterialColumnChartValuesResultType {
    salesPersonName: string | undefined;
    directCost: number;
    sellPrice: number;
}

export interface GetProjectModuleMaterialGroupColumnChartValuesResultType {
    salesPersonName: string | undefined;
    sellPrice: number;
    directCost: number;
}

export interface GetProjectModuleMaterialGroupLineChartValuesResultType {
    groupName: string | undefined;
    sellPrice: number;
    directCost: number;
    avgDirectCostPercentage: number;
    avgTDCPercentage: number;
}

export interface GetProjectModuleMaterialGroupMetricsValuesResultType {
    avgUnitCost: number;
    minUnitCost: number;
    medUnitCost: number;
    maxUnitCost: number;
    avgQuantity: number;
    minQuantity: number;
    medQuantity: number;
    maxQuantity: number;
    avgContingencyPercent: number;
    minContingencyPercent: number;
    medContingencyPercent: number;
    maxContingencyPercent: number;
    avgEscalationPercent: number;
    minEscalationPercent: number;
    medEscalationPercent: number;
    maxEscalationPercent: number;
    avgGrossMarginPercent: number;
    minGrossMarginPercent: number;
    medGrossMarginPercent: number;
    maxGrossMarginPercent: number;
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTDCPercentage: number;
    minTDCPercentage: number;
    medTDCPercentage: number;
    maxTDCPercentage: number;
}

export interface GetProjectModuleMaterialGroupValuesResultType {
    groupName: string | undefined;
    avgUnitCost: number;
    minUnitCost: number;
    medUnitCost: number;
    maxUnitCost: number;
    avgQuantity: number;
    minQuantity: number;
    medQuantity: number;
    maxQuantity: number;
    avgContingencyPercent: number;
    minContingencyPercent: number;
    medContingencyPercent: number;
    maxContingencyPercent: number;
    avgEscalationPercent: number;
    minEscalationPercent: number;
    medEscalationPercent: number;
    maxEscalationPercent: number;
    avgGrossMarginPercent: number;
    minGrossMarginPercent: number;
    medGrossMarginPercent: number;
    maxGrossMarginPercent: number;
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTDCPercentage: number;
    minTDCPercentage: number;
    medTDCPercentage: number;
    maxTDCPercentage: number;
}

export interface GetProjectModuleMaterialLineChartValuesResultType {
    partName: string | undefined;
    sellPrice: number;
    directCost: number;
    avgDirectCostPercentage: number;
    avgTDCPercentage: number;
}

export interface GetProjectModuleMaterialMetricsValuesResultType {
    avgUnitCost: number;
    minUnitCost: number;
    medUnitCost: number;
    maxUnitCost: number;
    avgQuantity: number;
    minQuantity: number;
    medQuantity: number;
    maxQuantity: number;
    avgContingencyPercent: number;
    minContingencyPercent: number;
    medContingencyPercent: number;
    maxContingencyPercent: number;
    avgEscalationPercent: number;
    minEscalationPercent: number;
    medEscalationPercent: number;
    maxEscalationPercent: number;
    avgGrossMarginPercent: number;
    minGrossMarginPercent: number;
    medGrossMarginPercent: number;
    maxGrossMarginPercent: number;
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTDCPercentage: number;
    minTDCPercentage: number;
    medTDCPercentage: number;
    maxTDCPercentage: number;
}

export interface GetProjectModuleMaterialValuesResultType {
    partName: string | undefined;
    avgUnitCost: number;
    minUnitCost: number;
    medUnitCost: number;
    maxUnitCost: number;
    avgQuantity: number;
    minQuantity: number;
    medQuantity: number;
    maxQuantity: number;
    avgContingencyPercent: number;
    minContingencyPercent: number;
    medContingencyPercent: number;
    maxContingencyPercent: number;
    avgEscalationPercent: number;
    minEscalationPercent: number;
    medEscalationPercent: number;
    maxEscalationPercent: number;
    avgGrossMarginPercent: number;
    minGrossMarginPercent: number;
    medGrossMarginPercent: number;
    maxGrossMarginPercent: number;
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTDCPercentage: number;
    minTDCPercentage: number;
    medTDCPercentage: number;
    maxTDCPercentage: number;
    nonStandard: boolean;
}

export interface GetProjectModuleMetricsValuesResultType {
    subcontractorGrossMarginPercent: number;
    subcontractorSellPrice: number;
    subcontractorPercent: number;
    expensesGrossMarginPercent: number;
    expensesGrossSellPrice: number;
    expensesPercent: number;
    customGrossMarginPercent: number;
    customSellPrice: number;
    customPercent: number;
    laborGrossMarginPercent: number;
    laborSellPrice: number;
    laborPercent: number;
    materialGrossMarginPercent: number;
    materialSellPrice: number;
    materialPercent: number;
}

export interface GetProjectModuleSubcontractorColumnChartValuesResultType {
    salesPersonName: string | undefined;
    totalSellPrice: number;
    totalSellPriceLumpSum: number;
    totalSellPriceUnitPricing: number;
    used: number;
}

export interface GetProjectModuleSubcontractorLineChartValuesResultType {
    subcontractorName: string | undefined;
    totalSellPrice: number;
    totalSellPriceLumpSum: number;
    totalSellPriceUnitPricing: number;
    used: number;
}

export interface GetProjectModuleSubcontractorMetricsValuesResultType {
    avgQuoteLumpSum: number;
    minQuoteLumpSum: number;
    medQuoteLumpSum: number;
    maxQuoteLumpSum: number;
    avgQuoteUnitPricing: number;
    minQuoteUnitPricing: number;
    medQuoteUnitPricing: number;
    maxQuoteUnitPricing: number;
    avgDirectCostLumpSum: number;
    minDirectCostLumpSum: number;
    medDirectCostLumpSum: number;
    maxDirectCostLumpSum: number;
    avgDirectCostUnitPricing: number;
    minDirectCostUnitPricing: number;
    medDirectCostUnitPricing: number;
    maxDirectCostUnitPricing: number;
    avgPercentageDirectCostLumpSum: number;
    minPercentageDirectCostLumpSum: number;
    medPercentageDirectCostLumpSum: number;
    maxPercentageDirectCostLumpSum: number;
    avgPercentageTotalDirectCostUnitPricing: number;
    minPercentageTotalDirectCostUnitPricing: number;
    medPercentageTotalDirectCostUnitPricing: number;
    maxPercentageTotalDirectCostUnitPricing: number;
}

export interface GetProjectModuleSubcontractorValuesResultType {
    subcontractorName: string | undefined;
    totalSellPrice: number;
    used: number;
    avgSellPricePerUsed: number;
    qtyFinalEstimates: number;
    avgSellPricePerFinalEstimates: number;
    lumpSumQty: number;
    unitPricingQty: number;
    totalSellPriceLumpSum: number;
    totalSellPriceUnitPricing: number;
    avgQuoteLumpSum: number;
    minQuoteLumpSum: number;
    medQuoteLumpSum: number;
    maxQuoteLumpSum: number;
    avgQuoteUnitPricing: number;
    minQuoteUnitPricing: number;
    medQuoteUnitPricing: number;
    maxQuoteUnitPricing: number;
    avgDirectCostLumpSum: number;
    minDirectCostLumpSum: number;
    medDirectCostLumpSum: number;
    maxDirectCostLumpSum: number;
    avgDirectCostUnitPricing: number;
    minDirectCostUnitPricing: number;
    medDirectCostUnitPricing: number;
    maxDirectCostUnitPricing: number;
    avgPercentageDirectCostLumpSum: number;
    minPercentageDirectCostLumpSum: number;
    medPercentageDirectCostLumpSum: number;
    maxPercentageDirectCostLumpSum: number;
    avgPercentageDirectCostUnitPricing: number;
    minPercentageDirectCostUnitPricing: number;
    medPercentageDirectCostUnitPricing: number;
    maxPercentageDirectCostUnitPricing: number;
    avgPercentageTotalDirectCostLumpSum: number;
    minPercentageTotalDirectCostLumpSum: number;
    medPercentageTotalDirectCostLumpSum: number;
    maxPercentageTotalDirectCostLumpSum: number;
    avgPercentageTotalDirectCostUnitPricing: number;
    minPercentageTotalDirectCostUnitPricing: number;
    medPercentageTotalDirectCostUnitPricing: number;
    maxPercentageTotalDirectCostUnitPricing: number;
}

export interface GetProjectModuleValuesResultType {
    projectName: string | undefined;
    estimateGrossMargin: number;
    estimateSellPrice: number;
    subcontractorGrossMarginPercent: number;
    subcontractorSellPrice: number;
    subcontractorPercent: number;
    expensesGrossMarginPercent: number;
    expensesGrossSellPrice: number;
    expensesPercent: number;
    customGrossMarginPercent: number;
    customSellPrice: number;
    customPercent: number;
    laborGrossMarginPercent: number;
    laborSellPrice: number;
    laborPercent: number;
    materialGrossMarginPercent: number;
    materialSellPrice: number;
    materialPercent: number;
}

export interface GetSalesLeadColumnChartValuesResultType {
    userId: number;
    salesPerson: string | undefined;
    totalPotentialValue: number;
    totalGMPercent: number;
}

export interface GetSalesLeadLineChartValuesResultType {
    leadName: string | undefined;
    potentialValue: number;
    potentialGrossMarginPercent: number;
}

export interface GetSalesLeadMetricsValuesResultType {
    avgPotentialValue: number;
    minPotentialValue: number;
    medPotentialValue: number;
    maxPotentialValue: number;
    avgPotentialGrossMarginPercent: number;
    minPotentialGrossMarginPercent: number;
    medPotentialGrossMarginPercent: number;
    maxPotentialGrossMarginPercent: number;
}

export interface GetSalesLeadValuesParameters {
    userId: number | undefined;
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    opportunityIds: number[] | undefined;
    opportunityCreationDateFrom: Date | undefined;
    opportunityCreationDateTo: Date | undefined;
    opportunityDueDateFrom: Date | undefined;
    opportunityDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    divisionIds: number[] | undefined;
    customerIds: number[] | undefined;
    accountIds: number[] | undefined;
    potentialValueFrom: number | undefined;
    potentialValueTo: number | undefined;
    probabilityValueFrom: number | undefined;
    probabilityValueTo: number | undefined;
    expectedResponseDateFrom: Date | undefined;
    expectedResponseDateTo: Date | undefined;
    includeArchived: boolean | undefined;
}

export interface GetSalesLeadValuesResultType {
    entityId: number;
    opportunityName: string | undefined;
    creationDate: Date;
    dueDate: Date | undefined;
    expectedBookingDate: Date | undefined;
    customer: string | undefined;
    account: string | undefined;
    potentialValue: number | undefined;
    potentialGrossMarginPercent: number | undefined;
    division: string | undefined;
    salesPerson: string | undefined;
    status: string | undefined;
    probability: string | undefined;
    speculativeValue: number;
    market: string | undefined;
    lead: string | undefined;
    organization: string | undefined;
    condition: string | undefined;
    opportunityLastUpdatedNote: string | undefined;
    modificationDate: Date | undefined;
    customFieldValues: string | undefined;
    customFieldColumnValues: CustomFieldColumnValueDto[] | undefined;
}

export interface GetSalesProjectsExtendedColumnChartValuesResultType {
    salesPerson: string | undefined;
    opportunityValue: number | undefined;
    bidAmount: number | undefined;
    awardedAmount: number | undefined;
}

export interface GetSalesProjectsLineChartValuesResultType {
    projectName: string | undefined;
    sellPrice: number;
    grossMargin: number;
}

export interface GetSalesProjectsMetricsValuesResultType {
    acceptedQty: number;
    acceptedProportion: number;
    rejectedQty: number;
    rejectedProportion: number;
    canceledQty: number;
    canceledProportion: number;
    onHoldQty: number;
    onHoldProportion: number;
}

export interface GetSalesProjectsSummaryValuesParameters {
    organizationIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
    projectIds: number[] | undefined;
    projectDueDateFrom: Date | undefined;
    projectDueDateTo: Date | undefined;
    projectStartDateFrom: Date | undefined;
    projectStartDateTo: Date | undefined;
    projectEndDateFrom: Date | undefined;
    projectEndDateTo: Date | undefined;
    projectStatusIds: number[] | undefined;
    markets: number[] | undefined;
    leads: number[] | undefined;
    competingBidderIds: number[] | undefined;
    userId: number | undefined;
}

export interface GetServiceCategoryColumnChartValuesResultType {
    salesPersonName: string | undefined;
    totalSellPrice: number;
    totalDirectCost: number;
}

export interface GetServiceCategoryLineChartValuesResultType {
    category: string | undefined;
    avgDirectCostPercentage: number;
    avgDirectCost: number;
    avgTotalDirectCostPercentage: number;
}

export interface GetServiceCategoryMetricsValuesResultType {
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetServiceCategoryValuesResultType {
    category: string | undefined;
    used: number;
    totalSellPrice: number;
    totalGrossMarginPercent: number;
    avgSellPrice: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetServiceCostColumnChartResultType {
    salesPersonName: string | undefined;
    sellPrice: number;
    totalDirectCost: number;
}

export interface GetServiceCostLineChartResultType {
    serviceName: string | undefined;
    avgDCPercent: number;
    avgDirectCost: number;
    avgTDCPercent: number;
    avgTDC: number;
}

export interface GetServiceCostMetricsResultType {
    avgDCPercent: number;
    minDCPercent: number;
    medDCPercent: number;
    maxDCPercent: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgTDCPercent: number;
    minTDCPercent: number;
    medTDCPercent: number;
    maxTDCPercent: number;
    avgTDC: number;
    minTDC: number;
    medTDC: number;
    maxTDC: number;
}

export interface GetServiceCostValuesResultType {
    serviceName: string | undefined;
    quantity: number;
    totalSellPrice: number;
    totalGMPercent: number;
    avgSellPrice: number;
    avgDCPercent: number;
    minDCPercent: number;
    medDCPercent: number;
    maxDCPercent: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgTDCPercent: number;
    minTDCPercent: number;
    medTDCPercent: number;
    maxTDCPercent: number;
    avgTDC: number;
    minTDC: number;
    medTDC: number;
    maxTDC: number;
}

export interface GetServiceMetricsValuesResultType {
    subcontractorGM: number;
    subcontractorSellPrice: number;
    subcontractorPercentage: number;
    expenseSellPrice: number;
    expenseGM: number;
    expensePercentage: number;
    estimateCustomGM: number;
    estimateCustomSellPrice: number;
    estimateCustomPercentage: number;
    materialCostSellPrice: number;
    materialCostGM: number;
    materialCostPercentage: number;
    laborCostSellPrice: number;
    laborCostGM: number;
    laborCostPercentage: number;
}

export interface GetServiceModuleCustomColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalSellPrice: number;
    totalCustomCost: number;
}

export interface GetServiceModuleCustomLineChartValuesResultType {
    description: string | undefined;
    totalSellPrice: number;
    totalCustomCost: number;
    avgDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
}

export interface GetServiceModuleCustomMetricsValuesResultType {
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgCustomCost: number;
    minCustomCost: number;
    medCustomCost: number;
    maxCustomCost: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetServiceModuleCustomValuesResultType {
    description: string | undefined;
    totalSellPrice: number;
    totalCustomCost: number;
    avgCustomCost: number;
    minCustomCost: number;
    medCustomCost: number;
    maxCustomCost: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetServiceModuleExpensesColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalSellPrice: number;
    totalExpenseCost: number;
}

export interface GetServiceModuleExpensesLineChartValuesResultType {
    expenseType: string | undefined;
    totalSellPrice: number;
    totalExpenseCost: number;
    avgDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
}

export interface GetServiceModuleExpensesMetricsValuesResultType {
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgExpenseCost: number;
    minExpenseCost: number;
    medExpenseCost: number;
    maxExpenseCost: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetServiceModuleExpensesValuesResultType {
    expenseType: string | undefined;
    totalSellPrice: number;
    totalExpenseCost: number;
    avgExpenseCost: number;
    minExpenseCost: number;
    medExpenseCost: number;
    maxExpenseCost: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetServiceModuleLaborRoleColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalHours: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetServiceModuleLaborRoleLineChartValuesResultType {
    laborRole: string | undefined;
    totalHours: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetServiceModuleLaborRoleMetricsValuesResultType {
    avgRegularHours: number;
    minRegularHours: number;
    medRegularHours: number;
    maxRegularHours: number;
    avgHoursOvertimeOne: number;
    minHoursOvertimeOne: number;
    medHoursOvertimeOne: number;
    maxHoursOvertimeOne: number;
    avgHoursOvertimeTwo: number;
    minHoursOvertimeTwo: number;
    medHoursOvertimeTwo: number;
    maxHoursOvertimeTwo: number;
    avgTotalHours: number;
    minTotalHours: number;
    medTotalHours: number;
    maxTotalHours: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
}

export interface GetServiceModuleLaborRoleValuesResultType {
    laborRole: string | undefined;
    avgRegularHours: number;
    minRegularHours: number;
    medRegularHours: number;
    maxRegularHours: number;
    avgHoursOvertimeOne: number;
    minHoursOvertimeOne: number;
    medHoursOvertimeOne: number;
    maxHoursOvertimeOne: number;
    avgHoursOvertimeTwo: number;
    minHoursOvertimeTwo: number;
    medHoursOvertimeTwo: number;
    maxHoursOvertimeTwo: number;
    avgTotalHours: number;
    minTotalHours: number;
    medTotalHours: number;
    maxTotalHours: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
}

export interface GetServiceModuleLaborTaskColumnChartValuesResultType {
    salesPerson: string | undefined;
    totalHours: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetServiceModuleLaborTaskLineChartValuesResultType {
    laborTask: string | undefined;
    totalHours: number;
    totalLaborCost: number;
    totalDirectCost: number;
}

export interface GetServiceModuleLaborTaskMetricsValuesResultType {
    avgRegularHours: number;
    minRegularHours: number;
    medRegularHours: number;
    maxRegularHours: number;
    avgHoursOvertimeOne: number;
    minHoursOvertimeOne: number;
    medHoursOvertimeOne: number;
    maxHoursOvertimeOne: number;
    avgHoursOvertimeTwo: number;
    minHoursOvertimeTwo: number;
    medHoursOvertimeTwo: number;
    maxHoursOvertimeTwo: number;
    avgTotalHours: number;
    minTotalHours: number;
    medTotalHours: number;
    maxTotalHours: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
}

export interface GetServiceModuleLaborTaskValuesResultType {
    laborCode: string | undefined;
    laborTask: string | undefined;
    avgRegularHours: number;
    minRegularHours: number;
    medRegularHours: number;
    maxRegularHours: number;
    avgHoursOvertimeOne: number;
    minHoursOvertimeOne: number;
    medHoursOvertimeOne: number;
    maxHoursOvertimeOne: number;
    avgHoursOvertimeTwo: number;
    minHoursOvertimeTwo: number;
    medHoursOvertimeTwo: number;
    maxHoursOvertimeTwo: number;
    avgTotalHours: number;
    minTotalHours: number;
    medTotalHours: number;
    maxTotalHours: number;
    avgLaborCost: number;
    minLaborCost: number;
    medLaborCost: number;
    maxLaborCost: number;
}

export interface GetServiceModuleMaterialColumnChartValuesResultType {
    salesPersonName: string | undefined;
    directCost: number;
    sellPrice: number;
}

export interface GetServiceModuleMaterialGroupColumnChartValuesResultType {
    salesPersonName: string | undefined;
    sellPrice: number;
    directCost: number;
}

export interface GetServiceModuleMaterialGroupLineChartValuesResultType {
    groupName: string | undefined;
    sellPrice: number;
    directCost: number;
    avgDirectCostPercentage: number;
    avgTDCPercentage: number;
}

export interface GetServiceModuleMaterialGroupMetricsValuesResultType {
    avgUnitCost: number;
    minUnitCost: number;
    medUnitCost: number;
    maxUnitCost: number;
    avgQuantity: number;
    minQuantity: number;
    medQuantity: number;
    maxQuantity: number;
    avgContingencyPercent: number;
    minContingencyPercent: number;
    medContingencyPercent: number;
    maxContingencyPercent: number;
    avgEscalationPercent: number;
    minEscalationPercent: number;
    medEscalationPercent: number;
    maxEscalationPercent: number;
    avgGrossMarginPercent: number;
    minGrossMarginPercent: number;
    medGrossMarginPercent: number;
    maxGrossMarginPercent: number;
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTDCPercentage: number;
    minTDCPercentage: number;
    medTDCPercentage: number;
    maxTDCPercentage: number;
}

export interface GetServiceModuleMaterialGroupValuesResultType {
    groupName: string | undefined;
    avgUnitCost: number;
    minUnitCost: number;
    medUnitCost: number;
    maxUnitCost: number;
    avgQuantity: number;
    minQuantity: number;
    medQuantity: number;
    maxQuantity: number;
    avgContingencyPercent: number;
    minContingencyPercent: number;
    medContingencyPercent: number;
    maxContingencyPercent: number;
    avgEscalationPercent: number;
    minEscalationPercent: number;
    medEscalationPercent: number;
    maxEscalationPercent: number;
    avgGrossMarginPercent: number;
    minGrossMarginPercent: number;
    medGrossMarginPercent: number;
    maxGrossMarginPercent: number;
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTDCPercentage: number;
    minTDCPercentage: number;
    medTDCPercentage: number;
    maxTDCPercentage: number;
}

export interface GetServiceModuleMaterialLineChartValuesResultType {
    partName: string | undefined;
    sellPrice: number;
    directCost: number;
    avgDirectCostPercentage: number;
    avgTDCPercentage: number;
}

export interface GetServiceModuleMaterialMetricsValuesResultType {
    avgUnitCost: number;
    minUnitCost: number;
    medUnitCost: number;
    maxUnitCost: number;
    avgQuantity: number;
    minQuantity: number;
    medQuantity: number;
    maxQuantity: number;
    avgContingencyPercent: number;
    minContingencyPercent: number;
    medContingencyPercent: number;
    maxContingencyPercent: number;
    avgEscalationPercent: number;
    minEscalationPercent: number;
    medEscalationPercent: number;
    maxEscalationPercent: number;
    avgGrossMarginPercent: number;
    minGrossMarginPercent: number;
    medGrossMarginPercent: number;
    maxGrossMarginPercent: number;
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTDCPercentage: number;
    minTDCPercentage: number;
    medTDCPercentage: number;
    maxTDCPercentage: number;
}

export interface GetServiceModuleMaterialValuesResultType {
    partName: string | undefined;
    avgUnitCost: number;
    minUnitCost: number;
    medUnitCost: number;
    maxUnitCost: number;
    avgQuantity: number;
    minQuantity: number;
    medQuantity: number;
    maxQuantity: number;
    avgContingencyPercent: number;
    minContingencyPercent: number;
    medContingencyPercent: number;
    maxContingencyPercent: number;
    avgEscalationPercent: number;
    minEscalationPercent: number;
    medEscalationPercent: number;
    maxEscalationPercent: number;
    avgGrossMarginPercent: number;
    minGrossMarginPercent: number;
    medGrossMarginPercent: number;
    maxGrossMarginPercent: number;
    avgSellPrice: number;
    minSellPrice: number;
    medSellPrice: number;
    maxSellPrice: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgTDCPercentage: number;
    minTDCPercentage: number;
    medTDCPercentage: number;
    maxTDCPercentage: number;
    nonStandard: boolean;
}

export interface GetServiceModuleSubcontractorColumnChartValuesResultType {
    salesPersonName: string | undefined;
    totalSellPrice: number;
    totalSellPriceLumpSum: number;
    totalSellPriceUnitPricing: number;
    used: number;
}

export interface GetServiceModuleSubcontractorLineChartValuesResultType {
    subcontractorName: string | undefined;
    totalSellPrice: number;
    totalSellPriceLumpSum: number;
    totalSellPriceUnitPricing: number;
    used: number;
}

export interface GetServiceModuleSubcontractorMetricsValuesResultType {
    avgQuoteLumpSum: number;
    minQuoteLumpSum: number;
    medQuoteLumpSum: number;
    maxQuoteLumpSum: number;
    avgQuoteUnitPricing: number;
    minQuoteUnitPricing: number;
    medQuoteUnitPricing: number;
    maxQuoteUnitPricing: number;
    avgDirectCostLumpSum: number;
    minDirectCostLumpSum: number;
    medDirectCostLumpSum: number;
    maxDirectCostLumpSum: number;
    avgDirectCostUnitPricing: number;
    minDirectCostUnitPricing: number;
    medDirectCostUnitPricing: number;
    maxDirectCostUnitPricing: number;
    avgPercentageDirectCostLumpSum: number;
    minPercentageDirectCostLumpSum: number;
    medPercentageDirectCostLumpSum: number;
    maxPercentageDirectCostLumpSum: number;
    avgPercentageTotalDirectCostUnitPricing: number;
    minPercentageTotalDirectCostUnitPricing: number;
    medPercentageTotalDirectCostUnitPricing: number;
    maxPercentageTotalDirectCostUnitPricing: number;
}

export interface GetServiceModuleSubcontractorValuesResultType {
    subcontractorName: string | undefined;
    totalSellPrice: number;
    used: number;
    avgSellPricePerUsed: number;
    qtyFinalEstimates: number;
    avgSellPricePerFinalEstimates: number;
    lumpSumQty: number;
    unitPricingQty: number;
    totalSellPriceLumpSum: number;
    totalSellPriceUnitPricing: number;
    avgQuoteLumpSum: number;
    minQuoteLumpSum: number;
    medQuoteLumpSum: number;
    maxQuoteLumpSum: number;
    avgQuoteUnitPricing: number;
    minQuoteUnitPricing: number;
    medQuoteUnitPricing: number;
    maxQuoteUnitPricing: number;
    avgDirectCostLumpSum: number;
    minDirectCostLumpSum: number;
    medDirectCostLumpSum: number;
    maxDirectCostLumpSum: number;
    avgDirectCostUnitPricing: number;
    minDirectCostUnitPricing: number;
    medDirectCostUnitPricing: number;
    maxDirectCostUnitPricing: number;
    avgPercentageDirectCostLumpSum: number;
    minPercentageDirectCostLumpSum: number;
    medPercentageDirectCostLumpSum: number;
    maxPercentageDirectCostLumpSum: number;
    avgPercentageDirectCostUnitPricing: number;
    minPercentageDirectCostUnitPricing: number;
    medPercentageDirectCostUnitPricing: number;
    maxPercentageDirectCostUnitPricing: number;
    avgPercentageTotalDirectCostLumpSum: number;
    minPercentageTotalDirectCostLumpSum: number;
    medPercentageTotalDirectCostLumpSum: number;
    maxPercentageTotalDirectCostLumpSum: number;
    avgPercentageTotalDirectCostUnitPricing: number;
    minPercentageTotalDirectCostUnitPricing: number;
    medPercentageTotalDirectCostUnitPricing: number;
    maxPercentageTotalDirectCostUnitPricing: number;
}

export interface GetServiceModulesColumnChartResultType {
    salesPersonName: string | undefined;
    subcontractorSellPrice: number;
    expenseSellPrice: number;
    customSellPrice: number;
    laborSellPrice: number;
    materialSellPrice: number;
}

export interface GetServiceModulesLineChartResultType {
    serviceName: string | undefined;
    sellPrice: number;
    grossMarginPercent: number;
}

export interface GetServiceModulesValuesResultType {
    serviceName: string | undefined;
    quantity: number;
    grossMargin: number;
    sellPrice: number;
    avgSellPrice: number;
    subcontractorGM: number;
    subcontractorSellPrice: number;
    subcontractorPercentage: number;
    expenseSellPrice: number;
    expenseGM: number;
    expensePercentage: number;
    estimateCustomGM: number;
    estimateCustomSellPrice: number;
    customPercentage: number;
    materialCostSellPrice: number;
    materialCostGM: number;
    materialCostPercentage: number;
    laborCostSellPrice: number;
    laborCostGM: number;
    laborCostPercentage: number;
}

export interface GetServiceSubCategoryColumnChartValuesResultType {
    salesPersonName: string | undefined;
    totalSellPrice: number;
    totalDirectCost: number;
}

export interface GetServiceSubCategoryLineChartValuesResultType {
    subCategory: string | undefined;
    avgDirectCostPercentage: number;
    avgDirectCost: number;
    avgTotalDirectCostPercentage: number;
}

export interface GetServiceSubCategoryMetricsValuesResultType {
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetServiceSubCategoryValuesResultType {
    subCategory: string | undefined;
    used: number;
    totalSellPrice: number;
    totalGrossMarginPercent: number;
    avgSellPrice: number;
    avgDirectCostPercentage: number;
    minDirectCostPercentage: number;
    medDirectCostPercentage: number;
    maxDirectCostPercentage: number;
    avgDirectCost: number;
    minDirectCost: number;
    medDirectCost: number;
    maxDirectCost: number;
    avgTotalDirectCostPercentage: number;
    minTotalDirectCostPercentage: number;
    medTotalDirectCostPercentage: number;
    maxTotalDirectCostPercentage: number;
}

export interface GetServiceTermsColumnChartResultType {
    salesPerson: string | undefined;
    sellPrice: number;
    tdc: number;
}

export interface GetServiceTermsLineChartResultType {
    term: string | undefined;
    sellPrice: number;
    grossMarginPercent: number;
}

export interface GetServiceTermsMetricsResultType {
    quantity: number;
    directCost: number;
    contingency: number;
    escalation: number;
    grossMargin: number;
    sellPrice: number;
    totalDirectCost: number;
    avgSellPrice: number;
    termNumber: number;
    avgSellPricePercentage: number;
    totalDirectCostPercent: number;
}

export interface GetServiceTermsMetricsResultTypeGetServiceTermsTotalizedValuesDetailsAndTotalizedResultDto {
    results: GetServiceTermsMetricsResultType[] | undefined;
    totalized: GetServiceTermsTotalizedValues;
}

export interface GetServiceTermsTotalizedValues {
    totalTerms: number;
    totalSellPrice: number;
    totalAvgSellPrice: number;
    avgSellPricePercents: number[] | undefined;
}

export interface GetServiceTermsValuesResultType {
    serviceName: string | undefined;
    usedInAwarded: number;
    totalSellPrice: number;
    gmPercentage: number;
    avgSellPrice: number;
    totalTerms: number;
    avgNumberOfTerms: number;
    qty1: number;
    gmPercentage1: number;
    sellPrice1: number;
    avgSellPrice1: number;
    sellPricePercentage1: number;
    qty2: number;
    gmPercentage2: number;
    sellPrice2: number;
    avgSellPrice2: number;
    sellPricePercentage2: number;
    qty3: number;
    gmPercentage3: number;
    sellPrice3: number;
    avgSellPrice3: number;
    sellPricePercentage3: number;
    qty4: number;
    gmPercentage4: number;
    sellPrice4: number;
    avgSellPrice4: number;
    sellPricePercentage4: number;
    qty5: number;
    gmPercentage5: number;
    sellPrice5: number;
    avgSellPrice5: number;
    sellPricePercentage5: number;
    qty6: number;
    gmPercentage6: number;
    sellPrice6: number;
    avgSellPrice6: number;
    sellPricePercentage6: number;
    qty7: number;
    gmPercentage7: number;
    sellPrice7: number;
    avgSellPrice7: number;
    sellPricePercentage7: number;
    qty8: number;
    gmPercentage8: number;
    sellPrice8: number;
    avgSellPrice8: number;
    sellPricePercentage8: number;
    qty9: number;
    gmPercentage9: number;
    sellPrice9: number;
    avgSellPrice9: number;
    sellPricePercentage9: number;
    qty10: number;
    gmPercentage10: number;
    sellPrice10: number;
    avgSellPrice10: number;
    sellPricePercentage10: number;
    qty11: number;
    gmPercentage11: number;
    sellPrice11: number;
    avgSellPrice11: number;
    sellPricePercentage11: number;
    qty12: number;
    gmPercentage12: number;
    sellPrice12: number;
    avgSellPrice12: number;
    sellPricePercentage12: number;
}

export interface LeadDto {
    id: number;
    name: string | undefined;
}

export interface MarketDto {
    id: number;
    name: string | undefined;
}

export interface OpportunityQuickSearchResultDto {
    id: number;
    name: string | undefined;
    isActive: boolean | undefined;
    organizationName: string | undefined;
}

export interface OrganizationDto {
    id: number;
    name: string | undefined;
}

export interface QuickSearchEstimatesParameters {
    filterText: string | undefined;
}

export interface QuickSearchEstimatesResultDto {
    id: number;
    name: string | undefined;
    organizationName: string | undefined;
}

export interface QuickSearchOpportunitiesParameters {
    filterText: string | undefined;
    organizations: number[] | undefined;
    isActive: boolean | undefined;
    opportunityIds: number[] | undefined;
}

export interface ReportResultColumnDto {
    displayName: string;
    propertyName: string;
    isFrozen: boolean;
    isCustomFieldColumn: boolean;
}

export interface ReportTemplateUserFavoriteView {
    id: number;
    userId: number;
    reportTemplateId: number;
    reportName: string | undefined;
    reportTemplateGroupId: number | undefined;
    reportTemplateUrl: string | undefined;
}

export interface ReportTemplateView {
    id: number;
    name: string | undefined;
    reportTemplateGroupId: number;
    reportTemplateGroupName: string | undefined;
    reportTemplateUrl: string | undefined;
    isActive: boolean | undefined;
    isFavorite: boolean | undefined;
    description: string | undefined;
    reportTemplateUserFavorites: ReportTemplateUserFavoriteView[] | undefined;
    canAddToCatalog: boolean;
}

export interface SchedulerDateRangeDto {
    id: number;
    name: string | undefined;
}

export interface SchedulerFrequencyDto {
    id: number;
    name: string | undefined;
}

export enum SchedulerStatuses {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface SchedulerTargetUserView {
    id: number;
    userId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
}

export interface SchedulerView {
    id: number;
    schedulerFrequencyId: number;
    customReportId: number;
    schedulerStatusId: number;
    schedulerDateRangeId: number;
    schedulerConfig: string | undefined;
    startDate: Date;
    endDate: Date | undefined;
    isActive: boolean | undefined;
    reportTemplateId: number | undefined;
    schedulerTargetUsers: SchedulerTargetUserView[] | undefined;
    sendTestExecution: boolean;
}

export interface SearchAccountsBasicDataParameters {
    filterText: string | undefined;
    organizations: number[] | undefined;
    isActive: boolean | undefined;
    accountIds: number[] | undefined;
}

export interface SearchAccountsBasicDataResultDto {
    id: number;
    name: string | undefined;
    isActive: boolean | undefined;
    organizationName: string | undefined;
}

export interface SearchCompaniesBasicDataParameters {
    filterText: string | undefined;
    organizations: number[] | undefined;
    isActive: boolean | undefined;
    companyIds: number[] | undefined;
}

export interface SearchCompaniesBasicDataResultDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    isActive: boolean | undefined;
    organizationName: string | undefined;
}

export interface SearchContactsBasicDataParameters {
    filterText: string | undefined;
    organizations: number[] | undefined;
    isActive: boolean | undefined;
    contactIds: number[] | undefined;
}

export interface SearchContactsBasicDataResultDto {
    id: number;
    fullName: string | undefined;
    isActive: boolean | undefined;
    organizationName: string | undefined;
}

export interface SearchDivisionsParameters {
    organizations: number[] | undefined;
    isActive: boolean | undefined;
    isReserved: boolean | undefined;
    divisionIds: number[] | undefined;
    filterText: string | undefined;
}

export interface SearchReportTemplateParameters {
    filterText: string | undefined;
    onlyFavorites: boolean;
    isActive: boolean | undefined;
    onlyScheduled: boolean;
}

export interface SearchUserDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    readonly fullName: string | undefined;
    isActive: boolean;
}

export interface SearchUsersParameters {
    filterText: string | undefined;
    isActive: boolean | undefined;
    userIds: number[] | undefined;
}

export interface SharedReportDto {
    url: string | undefined;
}

export interface UserDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    readonly fullName: string | undefined;
    isActive: boolean;
    organizations: OrganizationDto[] | undefined;
    userRoleId: number;
}

export class ApiError extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiError = true;

    static isApiError(obj: any): obj is ApiError {
        return obj.isApiError === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiError(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}